"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6346],{

/***/ 83677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CATEGORY_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment category on Category {\n    id\n    name\n    title\n    url\n    visible\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CATEGORY_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 4197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ CATEGORY_BY_ID_QUERY; }
/* harmony export */ });
/* unused harmony export CATEGORY_SIZE_CHART_QUERY */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70463);
/* harmony import */ var gql_fragments_category__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83677);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query CategoryById($id: String!) {\n    categoryById(id: $id) {\n      ...category\n      parentCategory {\n        ...category\n        parentCategory {\n          ...category\n          parentCategory {\n            ...category\n            parentCategory {\n              ...category\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query CategorySizeChart($id: String!) {\n    categoryById(id: $id) {\n      id\n      sizeCharts {\n        id\n        name\n        body\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CATEGORY_BY_ID_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), gql_fragments_category__WEBPACK_IMPORTED_MODULE_1__/* .CATEGORY_FRAGMENT */ .A);
var CATEGORY_SIZE_CHART_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 32952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pj": function() { return /* binding */ PRODUCT_QUERY; },
/* harmony export */   "YE": function() { return /* binding */ VARIANT_QUERY; }
/* harmony export */ });
/* unused harmony exports VARIANTS_QUERY, SIBLING_VARIANTS, PDP_QUERY, LAZY_PDP_QUERY, PRODUCT_SIZE_CHART_QUERY */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70463);
/* harmony import */ var gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19404);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Variants(\n    $input: VariantsInput!\n    $includeComparisonFields: Boolean = false\n  ) {\n    variants(input: $input) {\n      __typename\n      id\n      masterId\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n      }\n      ean\n      percentageDiscountBadge\n      name\n      variantId\n      header\n      subHeader\n      orderable\n      colorValue\n      colorName\n      displayOutOfStock {\n        displayValue\n      }\n      images {\n        href\n        alt\n      }\n      technology @include(if: $includeComparisonFields)\n      runTerrain @include(if: $includeComparisonFields)\n      weight @include(if: $includeComparisonFields)\n      heelToToeDrop @include(if: $includeComparisonFields)\n      fastener @include(if: $includeComparisonFields)\n      pronation @include(if: $includeComparisonFields)\n      refinementCushioningLevel @include(if: $includeComparisonFields)\n      runnerType @include(if: $includeComparisonFields)\n      mainMaterial @include(if: $includeComparisonFields)\n      cupType @include(if: $includeComparisonFields)\n      trouserRise @include(if: $includeComparisonFields)\n      pocketType @include(if: $includeComparisonFields)\n      apparelLength @include(if: $includeComparisonFields)\n      characteristics @include(if: $includeComparisonFields)\n      supportLevelBra @include(if: $includeComparisonFields)\n      studs @include(if: $includeComparisonFields)\n      playerLevel @include(if: $includeComparisonFields)\n      fit @include(if: $includeComparisonFields)\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query SiblingVariants($input: SiblingVariantsInput!) {\n    siblingVariants(input: $input) {\n      ...mandatoryVariantFields\n      badges {\n        id\n        label\n      }\n      percentageDiscountBadge\n      salePrice\n      productPrice {\n        price\n        salePrice\n        promotionPrice\n        isSalePriceElapsed\n        tax\n        taxRate\n      }\n      displayOutOfStock {\n        soldout\n        soldoutWithRecommender\n        comingsoon\n        backsoon\n        presale\n        displayValue\n      }\n      orderable\n      promotions(page: ProductListingPage) {\n        id\n        calloutMessage\n      }\n      isAppExclusive\n      appOnlyDateTimeFrom\n      appOnlyDateTimeTo\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Variant($id: ID!) {\n    variant(id: $id) {\n      id\n      masterId\n      name\n      colorValue\n      styleNumber\n      size {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Product($id: ID!) {\n    product(id: $id) {\n      id\n      name\n      header\n      subHeader\n      orderable\n      displayOutOfStock {\n        displayValue\n      }\n      variations {\n        id\n        name\n        colorValue\n        colorName\n        preview\n        price\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n        }\n        orderable\n        sizeGroups {\n          label\n          description\n          sizes {\n            id\n            label\n            value\n            productId\n            orderable\n            maxOrderableQuantity\n          }\n        }\n        displayOutOfStock {\n          soldout\n          soldoutWithRecommender\n          comingsoon\n          backsoon\n          presale\n          displayValue\n          validTo\n        }\n        images {\n          href\n          alt\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PDP($id: ID!, $viewAt: String) {\n    product(id: $id) {\n      ...mandatoryMasterFields\n      productNameTranslated\n      description\n      primaryCategoryId\n      productDivision\n      brand\n      disableRatings\n      disableReviews\n      amountOfReviews\n      averageRating\n      sizeChartId\n      promotions(page: ProductDetailsPage) {\n        id\n        calloutMessage\n      }\n      promotion {\n        id\n        calloutMessage\n      }\n      configureID {\n        enabled\n        productID\n      }\n      productStory {\n        longDescription\n        careInstructions\n        productKeywords\n      }\n      productVideos\n      verticalProductVideos\n      promotionExclusion\n      exploreMoreCTALabel\n      showExploreCollectionCTA\n      exploreMoreCTATargetCategoryID\n      brand\n      orderable\n      badge\n      ...sizes\n      fitOptions {\n        label\n        masterProduct {\n          id\n          name\n          variations {\n            id\n            colorValue\n            orderable\n          }\n        }\n      }\n      variations {\n        ...pdpMandatoryVariantFields\n        isFinalSale\n        returnRuleID\n        promotionExclusion\n        specialMessage(viewAt: $viewAt)\n        ean\n        validUntil\n        isAppExclusive\n        badges {\n          id\n          label\n        }\n        percentageDiscountBadge\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n          isSalePriceElapsed\n          tax\n          taxRate\n        }\n        styleNumber\n        materialComposition\n        displayOutOfStock {\n          soldout\n          soldoutWithRecommender\n          comingsoon\n          backsoon\n          presale\n          displayValue\n          validTo\n        }\n        orderable\n        modelMeasurementText\n        manufacturerInfo {\n          manufacturerAddress {\n            label\n            content\n          }\n          countryOfOrigin {\n            label\n            content\n          }\n        }\n        myCustomizer {\n          enabled\n          iframeID\n          startPoint\n        }\n        configureID {\n          enabled\n          productID\n        }\n        taxDisplayMsg\n        promotions(page: ProductDetailsPage) {\n          id\n          calloutMessage\n        }\n        appOnlyDateTimeFrom\n        appOnlyDateTimeTo\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query LazyPDP($id: ID!) {\n    product(id: $id) {\n      id\n      variations {\n        ...pdpMandatoryExtraVariantFields\n        description\n        productStory {\n          longDescription\n          materialComposition\n          careInstructions\n          manufacturerInfo {\n            manufacturerAddress {\n              label\n              content\n            }\n            countryOfOrigin {\n              label\n              content\n            }\n          }\n          productKeywords\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ProductSizeChart($id: [ID!]!) {\n    sizeCharts(ids: $id) {\n      id\n      name\n      body\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var VARIANTS_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
var SIBLING_VARIANTS = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .MANDATORY_VARIANT_FIELDS */ .EN);
var VARIANT_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var PRODUCT_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3());
var PDP_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4(), gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .PDP_MANDATORY_VARIANT_FIELDS */ .uQ, gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .MANDATORY_MASTER_FIELDS */ .YP, gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .SIZES_FRAGMENT */ .gm);
// Lazy PDP query to fetch non-critical product data azynchronously after the page has loaded, reducing the initial render.
var LAZY_PDP_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5(), gql_fragments_product__WEBPACK_IMPORTED_MODULE_1__/* .PDP_MANDATORY_EXTRA_VARIANT_FIELDS */ .MI);
var PRODUCT_SIZE_CHART_QUERY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject6());


/***/ }),

/***/ 67604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useDateFormatter; }
/* harmony export */ });
/* harmony import */ var _useSiteConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20368);
/* harmony import */ var _useTranslations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77480);


var weekDayNames = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday", 
];
var useDateFormatter = function(param) {
    var date = param.date, format = param.format, _text = param.text, text = _text === void 0 ? "emptyTranslation" : _text;
    var t = (0,_useTranslations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .qM)();
    var localizeDate = (0,_useSiteConfig__WEBPACK_IMPORTED_MODULE_0__/* .useSiteConfig */ .N)().localizeDate;
    if (!format) return localizeDate(date);
    var givenDate = new Date(date);
    var year = givenDate.getFullYear();
    var month = givenDate.getMonth() + 1;
    var day = givenDate.getDate();
    var weekDay = givenDate.getDay();
    var replacedParts = {
        YYYY: String(year),
        TY: t("year"),
        MM: String(month).padStart(2, "0"),
        TM: t("month"),
        DD: String(day).padStart(2, "0"),
        TD: t("day"),
        TW: t(weekDayNames[weekDay]),
        TEXT: t(text)
    };
    var _part;
    return format.reduce(function(result, part) {
        return result += (_part = replacedParts[part]) !== null && _part !== void 0 ? _part : part;
    }, "");
};


/***/ }),

/***/ 55587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useInventory; }
/* harmony export */ });
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37678);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79758);
/* harmony import */ var _useIsCrawler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32239);



var useInventory = function(productId) {
    var isCrawler = (0,_useIsCrawler__WEBPACK_IMPORTED_MODULE_2__/* .useIsCrawler */ .i)();
    var inventory = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .useInventoryQuery */ .ggB)({
        variables: {
            id: productId
        },
        pause: !productId || utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && !isCrawler,
        requestPolicy: "network-only"
    });
    return inventory;
};


/***/ }),

/***/ 70880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useProductCustomization; },
/* harmony export */   "V": function() { return /* binding */ ProductCustomizationProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);






var ProductCustomizationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var ProductCustomizationProvider = function(param) {
    var variation = param.variation, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), userProductCustomization = ref[0], setUserProductCustomization = ref[1];
    var isCustomizingProduct = !!router.query.customizing;
    var startCustomization = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return router.push({
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, router.query), {
                customizing: true
            })
        }, "", {
            scroll: true
        });
    }, [
        router
    ]);
    var customizationReceived = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(data) {
        // Remove customizing flag
        var _query = router.query, customizing = _query.customizing, query = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_query, [
            "customizing"
        ]);
        router.replace({
            query: query
        });
        var designImage = data.designImage, productionData = data.productionData, recipeID = data.id;
        var ref = productionData.reduce(function(ret, p) {
            ret[p.key] = p.value;
            return ret;
        }, {}), nameText = ref.Name, numberText = ref.Number;
        setUserProductCustomization({
            recipeId: recipeID,
            imageUrl: designImage.url,
            largeImageUrl: designImage.url,
            nameText: nameText,
            numberText: numberText
        });
    }, [
        router
    ]);
    // Clear user input if the next variant doesn't support customization
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (!(variation === null || variation === void 0 ? void 0 : (ref = variation.myCustomizer) === null || ref === void 0 ? void 0 : ref.enabled)) {
            setUserProductCustomization(undefined);
        }
    }, [
        variation
    ]);
    var clearUserProductCustomization = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setUserProductCustomization(undefined);
    }, []);
    var providerValue = {
        clearUserProductCustomization: clearUserProductCustomization,
        customizationReceived: customizationReceived,
        isCustomizingProduct: isCustomizingProduct,
        startCustomization: startCustomization,
        userProductCustomization: userProductCustomization
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCustomizationContext.Provider, {
        value: providerValue,
        children: children
    });
};
var useProductCustomization = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ProductCustomizationContext);
};


/***/ }),

/***/ 60581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ useWishlist; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./gql/queries/wishList.ts
var wishList = __webpack_require__(85288);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ./gql/fragments/wishList.ts
var fragments_wishList = __webpack_require__(46350);
;// CONCATENATED MODULE: ./gql/mutations/wishList.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddItemToWishList($input: AddItemToWishListInput!) {\n    addItemToWishList(input: $input) {\n      ...wishListFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateItemInWishList($input: UpdateItemInWishListInput!) {\n    updateItemInWishList(input: $input) {\n      ...wishListFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveItemFromWishList($input: RemoveItemFromWishListInput!) {\n    removeItemFromWishList(input: $input)\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ADD_ITEM_TO_WISHLIST_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject(), fragments_wishList/* WISHLIST_FRAGMENT */.j);
var UPDATE_ITEM_IN_WISHLIST_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject1(), fragments_wishList/* WISHLIST_FRAGMENT */.j);
var REMOVE_ITEM_FROM_WISHLIST_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject2());

// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
;// CONCATENATED MODULE: ./hooks/useWishlist.ts













var useWishlist = function(pause, shouldOpenMiniCart) {
    var auth = (0,useAuth/* useAuth */.aC)();
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref = (0,useGA4Events/* useGA4Events */.tL)(), imageType = ref.imageType, imageNumber = ref.imageNumber;
    var openMiniCart = (0,useMiniCart/* useMiniCart */.lm)().openMiniCart;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: wishList/* WISHLIST_QUERY */.z,
        pause: !!auth.guest || isServer || pause
    }), 1), wishlist = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(ADD_ITEM_TO_WISHLIST_MUTATION), 2), _ = ref2[0], addItemToWishList = ref2[1];
    var addItemToWishListCallback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variables) {
            var ref, _tmp, res, item, _quantity;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PDP_INTERACTION */._q.PDP_INTERACTION, (_tmp.domevent = "wishlist - add", _tmp.domlabel = "".concat(variables.input.productId, "_").concat(variables.input.swatch), _tmp));
                        return [
                            4,
                            addItemToWishList(variables)
                        ];
                    case 1:
                        res = _state.sent();
                        item = (ref = res.data) === null || ref === void 0 ? void 0 : ref.addItemToWishList.items.find(function(x) {
                            return x.product.masterId === variables.input.productId && x.product.colorValue === variables.input.swatch && x.product.size.value === variables.input.size;
                        });
                        if (item) {
                            if (shouldOpenMiniCart) {
                                openMiniCart(item);
                            }
                            ;
                            (0,analytics/* addToWishListEvent */.XO)(currency === null || currency === void 0 ? void 0 : currency.code, item, (_quantity = variables.input.quantity) !== null && _quantity !== void 0 ? _quantity : undefined, imageType, imageNumber);
                        }
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function addItemToWishListCallback(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(UPDATE_ITEM_IN_WISHLIST_MUTATION), 2), updateItemInWishList = ref3[1];
    var updateItemInWishListCallback = (0,react.useCallback)(function(variables) {
        return updateItemInWishList(variables, {
            additionalTypenames: [
                "WishList"
            ]
        });
    }, [
        updateItemInWishList
    ]);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(REMOVE_ITEM_FROM_WISHLIST_MUTATION), 2), removeItemFromWishList = ref4[1];
    var removeItemFromWishListCallback = (0,react.useCallback)(function(variables) {
        return removeItemFromWishList(variables, {
            additionalTypenames: [
                "WishList"
            ]
        });
    }, [
        removeItemFromWishList
    ]);
    return [
        wishlist,
        {
            add: addItemToWishListCallback,
            update: updateItemInWishListCallback,
            remove: removeItemFromWishListCallback
        }, 
    ];
};


/***/ }),

/***/ 15550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20769);
/* harmony import */ var ui_components_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87150);




var NotFoundPage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Page__WEBPACK_IMPORTED_MODULE_3__/* .Page */ .T, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_NoSearchResults__WEBPACK_IMPORTED_MODULE_2__/* .NoSearchResults */ .qx, {
            message: message
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ }),

/***/ 37404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/string-strip-html/dist/string-strip-html.cjs.js
var string_strip_html_cjs = __webpack_require__(50967);
// EXTERNAL MODULE: ./utils/removeHyphens.ts
var removeHyphens = __webpack_require__(47802);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(59308);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ./utils/isContentOnline.ts
var isContentOnline = __webpack_require__(89996);
// EXTERNAL MODULE: ./utils/breadcrumbRedirects.ts + 1 modules
var breadcrumbRedirects = __webpack_require__(5567);
;// CONCATENATED MODULE: ./hooks/useBreadcrumbUrlRedirects.ts








var isRedirectActive = function(redirect) {
    var availableFrom = redirect.availableFrom, availableTo = redirect.availableTo;
    var isAvailable = (0,isContentOnline/* isContentOnline */.e)({
        onlineFrom: availableFrom,
        onlineTo: availableTo
    }, {});
    if (!isAvailable || !redirect.url) return false;
    return true;
};
var useBreadcrumbUrlRedirects = function(links) {
    var client = (0,urql_es/* useClient */.m8)();
    var ref = (0,react.useState)(undefined), redirections = ref[0], setRedirections = ref[1];
    var fetchRedirections = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var breadcrumbPromises, results, updatedPaths, _tmp, _tmp1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    breadcrumbPromises = (0,breadcrumbRedirects/* fetchBreadcrumbRedirectPromises */.VD)(client, links);
                    return [
                        4,
                        Promise.all(breadcrumbPromises)
                    ];
                case 1:
                    results = _state.sent();
                    updatedPaths = results.map(function(param, idx) {
                        var data = param.data;
                        return data && isRedirectActive(data.urlRedirectV2) ? {
                            label: links[idx + 1].label,
                            url: data.urlRedirectV2.url
                        } : (0,_object_spread/* default */.Z)({}, links[idx + 1]);
                    });
                    _tmp = {};
                    _tmp1 = {};
                    if (updatedPaths.length > 0) {
                        setRedirections([
                            (0,_object_spread/* default */.Z)(_tmp, links[0])
                        ].concat((0,_to_consumable_array/* default */.Z)(updatedPaths), [
                            (0,_object_spread/* default */.Z)(_tmp1, links[links.length - 1])
                        ]));
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        client,
        links
    ]);
    return {
        fetchRedirections: fetchRedirections,
        redirections: redirections
    };
};

// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
;// CONCATENATED MODULE: ./ui/components/Breadcrumb.tsx
















var Breadcrumb = function(param) {
    var path = param.path, isPdpFromPlp = param.isPdpFromPlp;
    var router = (0,next_router.useRouter)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), host = ref.host, locale = ref.locale, absoluteLinkBreadcrumb = ref.absoluteLinkBreadcrumb, isPNARegion = ref.staticFeatures.isPNARegion;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var protocol = constants/* isServer */.sk ? "https:" : window.location.protocol;
    var baseUrlLink = "".concat(protocol, "//").concat(host).concat((0,utils_locale/* getUrlFromLocale */.bH)(locale));
    var baseUrl = absoluteLinkBreadcrumb ? baseUrlLink : "";
    var pdpUrlRegex = /^[a-z]{2}\/[a-z]{2}\/pd\/.*\/\\d{6,}/;
    var isPdp = pdpUrlRegex.test(router.pathname);
    // Build links array
    var links = (0,react.useMemo)(function() {
        return path.filter(function(pathElement) {
            return pathElement.url !== "/puma";
        }).map(function(param) {
            var label = param.label, url = param.url;
            var displayLabel = isPdp ? (0,removeHyphens/* removeHyphens */.V)(label) : label === "home" ? t("home") : label;
            var fullUrl = "".concat(baseUrl, "/").concat(encodeURI(url.length && url[0] === "/" ? url.slice(1) : url));
            return {
                label: displayLabel,
                url: fullUrl
            };
        });
    }, [
        path,
        isPdp,
        t,
        host,
        locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var ref1 = useBreadcrumbUrlRedirects(links), redirections = ref1.redirections, fetchRedirections = ref1.fetchRedirections;
    (0,react.useEffect)(function() {
        if (isPNARegion && links.length > 0) {
            fetchRedirections();
        }
    }, [
        isPNARegion,
        links.length,
        fetchRedirections
    ]);
    var prevToLastLink = links[links.length - 2] || links[0];
    var showMobilePdpBreadcrumb = !(0,media/* getIsDesktop */.w)() && isPdpFromPlp;
    var removeTrailingSlash = function(url) {
        return url.endsWith("/") ? url.slice(0, -1) : url;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showMobilePdpBreadcrumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "flex items-center font-bold",
                onClick: function() {
                    return router.back();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-0.5 mr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            size: "sm",
                            name: "chevron-left"
                        })
                    }),
                    prevToLastLink.label
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Breadcrumb */.aGc, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* FITANALYTICS_IS_LOADED_INDICATOR */.S7), {
                path: redirections !== null && redirections !== void 0 ? redirections : links,
                className: "-ml-1.5"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                type: "application/ld+json",
                script: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    itemListElement: links.map(function(item, index) {
                        return {
                            "@type": "ListItem",
                            position: index + 1,
                            name: (0,capitalize/* capitalize */.k)((0,string_strip_html_cjs.stripHtml)(item.label).result),
                            item: item.url.startsWith("http") ? item.url : removeTrailingSlash("".concat(baseUrlLink).concat(item.url)),
                            logo: "https://".concat(host, "/assets/logo-puma-black.png")
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 39220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CarouselModal": function() { return /* binding */ CarouselModal; },
/* harmony export */   "isVideo": function() { return /* binding */ isVideo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65781);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49224);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12601);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51377);
/* harmony import */ var hooks_useHorizontalScroll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42833);
/* harmony import */ var hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69340);
/* harmony import */ var ui_components_Video__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79817);
/* harmony import */ var ui_pages_ProductDetailsPages_ProductVideoMuteButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5972);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83168);
/* harmony import */ var utils_media__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39772);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77480);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6485);
/* harmony import */ var _ChevronButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24393);


















var isVideo = function(checkitem) {
    return (checkitem === null || checkitem === void 0 ? void 0 : checkitem.__typename) === "ProductVideo";
};
var SocialImage = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(param, ref) {
    var image = param.image, isSocialIconVisible = param.isSocialIconVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isSocialIconVisible && image.source && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute z-10 top-3 right-3 text-puma-black-300",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO$, {
                    name: "social-" + image.source,
                    size: "3xl"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: "max-h-screen",
                src: image.href,
                alt: image.alt,
                ref: ref
            }, image.href)
        ]
    });
});
SocialImage.displayName = "SocialImage";
var DisplayItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(param, ref) {
    var item = param.item, isSocialIconVisible = param.isSocialIconVisible, isGalleryVideoMuted = param.isGalleryVideoMuted;
    switch(item.__typename){
        case "ProductVideo":
            var video = item;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Video__WEBPACK_IMPORTED_MODULE_8__/* .Video */ .n, {
                src: video.src,
                videoOptions: video.videoOptions,
                muted: isGalleryVideoMuted,
                className: "max-h-screen",
                ref: ref
            });
        case "PixleeImg":
            var socialImage = item;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialImage, {
                image: socialImage,
                isSocialIconVisible: isSocialIconVisible,
                ref: ref
            });
        default:
            var image = item;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: "max-h-screen",
                src: image.href,
                alt: image.alt,
                ref: ref
            }, image.href);
    }
});
DisplayItem.displayName = "DisplayItem";
var MAX_ZOOM = 2;
var ZoomImage = function(param) {
    var image = param.image, pos = param.pos, setPicTracker = param.setPicTracker, isSocialIconVisible = param.isSocialIconVisible, isVideoMuted = param.isVideoMuted;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isZoomed = ref[0], setIsZoomed = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var resetTransformCallback;
    (0,hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_7__/* .useIntersectionObserver */ .S)(ref1, function() {
        return setPicTracker(pos);
    }, true, {
        threshold: 1
    }, function() {
        return resetTransformCallback(100, "linear");
    });
    var key = isVideo(image) ? image.src : image.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        "data-test-id": "gallery-image",
        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("flex items-center justify-center w-full h-full flex-none", (0,twind_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
            scrollSnapAlign: "start"
        })),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__/* .TransformWrapper */ .d$, {
            doubleClick: {
                disabled: true
            },
            centerOnInit: true,
            panning: {
                disabled: (0,utils_media__WEBPACK_IMPORTED_MODULE_11__/* .getIsMobile */ .W)() || !isZoomed,
                lockAxisY: true
            },
            wheel: {
                disabled: (0,utils_media__WEBPACK_IMPORTED_MODULE_11__/* .getIsMobile */ .W)(),
                step: 0.06
            },
            maxScale: 2.5,
            children: function(param) {
                var setTransform = param.setTransform, resetTransform = param.resetTransform, state = param.state;
                resetTransformCallback = resetTransform;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: function(event) {
                        if (state.scale < MAX_ZOOM) {
                            setTransform(Number((state.positionX - event.nativeEvent.clientX * 0.75).toFixed(2)), Number((state.positionY - event.nativeEvent.clientY * 0.75).toFixed(2)), state.scale + 0.75);
                        } else {
                            resetTransform();
                        }
                        setIsZoomed(state.scale < MAX_ZOOM);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_zoom_pan_pinch__WEBPACK_IMPORTED_MODULE_2__/* .TransformComponent */ .Uv, {
                        wrapperStyle: {
                            cursor: state.scale > MAX_ZOOM ? "zoom-out" : "zoom-in",
                            overflow: state.scale > 1 ? "visible" : "hidden"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DisplayItem, {
                            item: image,
                            isGalleryVideoMuted: isVideoMuted,
                            isSocialIconVisible: isSocialIconVisible,
                            ref: ref1
                        })
                    })
                });
            }
        })
    }, key);
};
var CarouselModal = function(param) {
    var _pixleeImages = param.pixleeImages, pixleeImages = _pixleeImages === void 0 ? [] : _pixleeImages, modalState = param.modalState, onClose = param.onClose, isSocialIconVisible = param.isSocialIconVisible, _galleryItems = param.galleryItems, galleryItems = _galleryItems === void 0 ? [] : _galleryItems, triggerEvent = param.triggerEvent;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_12__/* .useTranslate */ .qM)();
    var images = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return galleryItems.concat(pixleeImages).map(function(image, i) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, image), {
                pos: i + 1
            });
        });
    }, [
        pixleeImages,
        galleryItems
    ]);
    var carouselImages = images.length > 1 ? [
        images[images.length - 1]
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(images), [
        images[0]
    ]) : images;
    var mainImageContainer = (0,hooks_useHorizontalScroll__WEBPACK_IMPORTED_MODULE_6__/* .useHorizontalScroll */ .m)({
        infinite: true
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(modalState.picIndex + 1), picTracker = ref[0], setPicTracker = ref[1];
    var ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref1 = modalState === null || modalState === void 0 ? void 0 : modalState.muted) !== null && ref1 !== void 0 ? ref1 : true), isGalleryVideoMuted = ref2[0], setIsGalleryVideoMuted = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setTimeout(function() {
            return mainImageContainer.scrollToSelected(modalState.picIndex + 1);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var scroller = mainImageContainer.ref.current;
        var updateScroll = function() {
            if (scroller.scrollLeft === 0 && picTracker === images.length) {
                mainImageContainer.scrollToSelected(picTracker);
            } else if (scroller.scrollLeft + scroller.clientWidth === scroller.scrollWidth && picTracker === 1) {
                mainImageContainer.scrollToSelected(picTracker);
            }
        };
        updateScroll();
        document.addEventListener("scroll", updateScroll);
        return function() {
            return document.removeEventListener("scroll", updateScroll);
        };
    }, [
        picTracker,
        images.length,
        mainImageContainer
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var img = images[picTracker - 1];
        // This is a PISA product image not a video or pixlee image
        if (img.__typename !== "ProductImage") return;
        // We are not on the image that the gallery was initially loaded with
        if (picTracker - 1 !== modalState.picIndex) {
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_10__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_10__/* .AnalyticsEvents.PDP_INTERACTION */ ._q.PDP_INTERACTION, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                interactionType: "Gallery View"
            }, (0,utils_analytics__WEBPACK_IMPORTED_MODULE_10__/* .transformImageUrlToImageInteractionAnalyticsEvent */ .bA)(img.href)));
        }
        if (triggerEvent) {
            triggerEvent();
        }
    }, [
        picTracker
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var muteVideoOnChangeSlide = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (isVideo(carouselImages[picTracker])) {
            setIsGalleryVideoMuted(true);
        }
    }, [
        picTracker
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        layout: "fullscreen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                className: "absolute right-5 top-5 z-50",
                onClick: onClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "order-1 relative group-images h-[".concat(window === null || window === void 0 ? void 0 : window.innerHeight, "px]"),
                "data-test-id": "gallery-modal-zoom",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        tabIndex: 0,
                        role: "group",
                        "aria-label": "Gallery",
                        className: "absolute inset-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            ref: mainImageContainer.ref,
                            "data-test-id": "gallery-images",
                            className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("flex w-full h-full relative overflow-x-scroll no-scrollbars!", (0,twind_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
                                scrollSnapType: "x mandatory"
                            })),
                            children: carouselImages.map(function(image, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ZoomImage, {
                                    image: image,
                                    isVideoMuted: isGalleryVideoMuted,
                                    pos: image.pos,
                                    setPicTracker: setPicTracker,
                                    isSocialIconVisible: isSocialIconVisible
                                }, i + 1);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ChevronButton__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        className: "absolute left-2 top-1/2 transform -translate-y-1/2",
                        label: t("scrollLeft"),
                        onClick: function() {
                            muteVideoOnChangeSlide();
                            mainImageContainer.prev();
                        },
                        disabled: !mainImageContainer.hasPrev,
                        direction: "left"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ChevronButton__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        className: "absolute right-2 top-1/2 transform -translate-y-1/2",
                        label: t("scrollRight"),
                        disabled: !mainImageContainer.hasNext,
                        direction: "right",
                        onClick: function() {
                            muteVideoOnChangeSlide();
                            mainImageContainer.next();
                        }
                    }),
                    isVideo(carouselImages[picTracker]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_pages_ProductDetailsPages_ProductVideoMuteButton__WEBPACK_IMPORTED_MODULE_9__/* .ProductVideoMuteButton */ .$, {
                        isMuted: isGalleryVideoMuted,
                        setIsMuted: setIsGalleryVideoMuted,
                        className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("bg-white text-black rounded-full border-transparent absolute bottom-10 right-3.5 z-10 m-0 p-2")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "absolute bottom-12 left-12",
                "data-test-id": "image-gallery-tracker-position",
                children: [
                    picTracker.toString().padStart(2, "0"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "inline-block bg-black h-px my-1 mx-2.5 w-7"
                    }),
                    images.length.toString().padStart(2, "0")
                ]
            })
        ]
    });
};


/***/ }),

/***/ 57965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ConfirmModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70868);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51377);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6485);







var ConfirmModal = function(param) {
    var onClickOutside = param.onClickOutside, children = param.children, onConfirm = param.onConfirm, dataTestId = param.dataTestId, loading = param.loading, confirmText = param.confirmText, cancelText = param.cancelText, reverseButtonOrder = param.reverseButtonOrder;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var confirmButton = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
            id: "confirm-button",
            dataTestId: "confirm-button",
            loading: loading,
            label: confirmText !== null && confirmText !== void 0 ? confirmText : t("confirmButtonModal"),
            className: "flex-grow h-[2.5rem]",
            onClick: onConfirm,
            children: confirmText !== null && confirmText !== void 0 ? confirmText : t("confirmButtonModal")
        });
    };
    var cancelButton = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
            id: "cancel-button",
            dataTestId: "cancel-button",
            label: cancelText !== null && cancelText !== void 0 ? cancelText : t("cancelButtonModal"),
            variant: reverseButtonOrder ? "secondary" : "primary",
            className: "flex-grow",
            onClick: onClickOutside
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClickOutside: onClickOutside,
        variant: "dark",
        className: "max-w-lg p-6",
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "absolute top-5 right-5 !mt-0",
                onClick: onClickOutside
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-6",
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex space-x-4 w-full",
                        children: reverseButtonOrder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                cancelButton(),
                                confirmButton()
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                confirmButton(),
                                cancelButton()
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 6411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ PixleeProductWidget; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43218);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20368);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37678);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79758);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77480);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43308);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83168);
/* harmony import */ var hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32736);











var PIXLEE_PRODUCT_WIDGET_DEFAULT_CONTAINER_ID = "pixlee_container";
var addPixleeWidget = function(param) {
    var containerId = param.containerId, skuId = param.skuId, widgetId = param.widgetId, receiveMessage = param.receiveMessage;
    window.Pixlee.addProductWidget({
        AB: false,
        accountId: "1372",
        containerId: containerId,
        setMetaTags: false,
        skuId: skuId,
        subscribedEvents: [
            "photoOpened",
            "widgetNumPhotos",
            "ctaClicked"
        ],
        widgetId: widgetId
    });
    window.Pixlee.resizeWidget();
    window.addEventListener("message", receiveMessage, false);
};
var initPixlee = function(apiKey) {
    window.PixleeAsyncInit = function() {
        window.Pixlee.init({
            apiKey: apiKey
        });
    };
};
var PixleeProductWidget = function(param) {
    var _containerId = param.containerId, containerId = _containerId === void 0 ? PIXLEE_PRODUCT_WIDGET_DEFAULT_CONTAINER_ID : _containerId, skuId = param.skuId;
    var ref;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_6__/* .useTranslate */ .qM)();
    var pageviewEventHasFired = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var ref1 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__/* .useSiteConfig */ .N)(), env = ref1.env, language = ref1.language, pixleeId = ref1.pixleeId;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .usePixleeConfigQuery */ .QW$)(), 1), pixleeConfigResponse = ref2[0];
    var pixleeConfig = (ref = pixleeConfigResponse.data) === null || ref === void 0 ? void 0 : ref.pixleeConfig;
    var widgetId = pixleeId === null || pixleeId === void 0 ? void 0 : pixleeId[language];
    var shouldInitPixlee = !utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .isServer */ .sk && widgetId && (pixleeConfig === null || pixleeConfig === void 0 ? void 0 : pixleeConfig.enable);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), widgetAdded = ref3[0], setWidgetAdded = ref3[1];
    var setPixleeProductDiscovery = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__/* .usePageEventsContext */ .qN)().setPixleeProductDiscovery;
    var pixleeData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({
        item_id_ep: "",
        item_name_ep: ""
    });
    var pixleeProductWidgetRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var gaTrackData = {
        id: skuId,
        promotion_id: widgetId || "",
        name: "As Worn By You",
        creative: "pixlee",
        creative_name: "PixleeSimpleWidget",
        position: "1"
    };
    (0,hooks_usePromotionView__WEBPACK_IMPORTED_MODULE_9__/* .usePromotionView */ .Y)(pixleeProductWidgetRef, gaTrackData);
    var receiveMessage = function(e) {
        if (!e) return;
        if (e.data) {
            try {
                var ref;
                var message = JSON.parse(e.data);
                var photoOpenedMessage = message.eventName === "photoOpened";
                if (photoOpenedMessage && (message === null || message === void 0 ? void 0 : (ref = message.data) === null || ref === void 0 ? void 0 : ref.products[0])) {
                    var ref1, ref2;
                    pixleeData.current = {
                        item_id_ep: message === null || message === void 0 ? void 0 : (ref1 = message.data) === null || ref1 === void 0 ? void 0 : ref1.products[0].sku,
                        item_name_ep: message === null || message === void 0 ? void 0 : (ref2 = message.data) === null || ref2 === void 0 ? void 0 : ref2.products[0].title
                    };
                }
                var _current = pixleeData.current, item_id_ep = _current.item_id_ep, item_name_ep = _current.item_name_ep;
                if (message.eventName && message.eventName === "ctaClicked") {
                    if (pageviewEventHasFired) {
                        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                            event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.PIXLEE */ ._q.PIXLEE,
                            event_params: {
                                user_action: utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.GA4_PRODUCT_CLICK */ ._q.GA4_PRODUCT_CLICK,
                                item_id_ep: item_id_ep,
                                item_name_ep: item_name_ep
                            }
                        });
                    }
                    setPixleeProductDiscovery(true);
                }
                if (message.eventName && photoOpenedMessage) {
                    var photoIndex = message.data.photoIndex.toString();
                    if (pageviewEventHasFired) {
                        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                            event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.PIXLEE */ ._q.PIXLEE,
                            event_params: {
                                user_action: "pixlee_open",
                                item_id_ep: item_id_ep,
                                item_name_ep: item_name_ep
                            }
                        });
                    }
                    (0,utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.PROMOTION_CLICK */ ._q.PROMOTION_CLICK, {
                        ecommerce: {
                            promoClick: {
                                promotions: [
                                    {
                                        id: skuId,
                                        name: "As Worn By You",
                                        creative: "pixlee",
                                        position: photoIndex
                                    }, 
                                ]
                            }
                        }
                    });
                }
            } catch (error) {
                return;
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            var ref;
            window.removeEventListener("message", receiveMessage, false);
            (ref = window.Pixlee) === null || ref === void 0 ? void 0 : ref.close();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!shouldInitPixlee) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "https://assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js",
                onReady: function() {
                    initPixlee(env.pixleeApiKey);
                    if (!widgetAdded) {
                        addPixleeWidget({
                            containerId: containerId,
                            skuId: skuId,
                            widgetId: widgetId,
                            receiveMessage: receiveMessage
                        });
                        setWidgetAdded(true);
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                "data-test-id": "pixlee-product-widget",
                "aria-label": t("pixleeSectionTitle"),
                id: containerId,
                ref: pixleeProductWidgetRef
            })
        ]
    });
};


/***/ }),

/***/ 7681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ProductPromotions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var utils_isNotNullish__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50597);
/* harmony import */ var _elements_SafeHtml__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99671);




var ProductPromotion = function(props) {
    var ref;
    return ((ref = props.promotion) === null || ref === void 0 ? void 0 : ref.calloutMessage) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_SafeHtml__WEBPACK_IMPORTED_MODULE_2__/* .SafeHtml */ .T, {
        html: props.promotion.calloutMessage,
        as: "p",
        className: "text-red-600 font-bold",
        "data-test-id": "promotion-callout-message"
    }) : null;
};
var ProductPromotions = function(props) {
    var ref, ref1, ref2, ref3;
    var promotions = (ref = props.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.promotions) === null || ref1 === void 0 ? void 0 : ref1.filter(utils_isNotNullish__WEBPACK_IMPORTED_MODULE_3__/* .isNotNullish */ .l);
    var displayOutOfStock = (ref2 = props.variant) === null || ref2 === void 0 ? void 0 : ref2.displayOutOfStock;
    return ((ref3 = props.variant) === null || ref3 === void 0 ? void 0 : ref3.orderable) && !(displayOutOfStock === null || displayOutOfStock === void 0 ? void 0 : displayOutOfStock.comingsoon) && (promotions === null || promotions === void 0 ? void 0 : promotions.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: props.compact ? "text-xs" : "space-y-2",
        children: promotions.map(function(promo) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductPromotion, {
                promotion: promo
            }, promo.id);
        })
    }) : null;
};


/***/ }),

/***/ 71759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ ProductStory; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ./utils/html.ts
var utils_html = __webpack_require__(46001);
// EXTERNAL MODULE: ./ui/elements/SafeHtml.tsx
var SafeHtml = __webpack_require__(99671);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
;// CONCATENATED MODULE: ./ui/components/ProductStoryKeywords.tsx







function ProductStoryKeywords(param) {
    var productKeywords = param.productKeywords;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var showProductStoryKeywordTitle = (0,useFeature/* useFeature */.S)("SHOW_PRODUCT_STORY_KEYWORD_TITLE");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (productKeywords === null || productKeywords === void 0 ? void 0 : productKeywords.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-6 font-bold",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    showProductStoryKeywordTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-black-700",
                        children: "".concat(t("productStoryKeywordTitle"), ": ")
                    }),
                    productKeywords === null || productKeywords === void 0 ? void 0 : productKeywords.map(function(keyword, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,twind.tw)(":hover:underline"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/".concat(router.query.country, "/").concat(router.query.language, "/search?q=").concat(keyword),
                                        children: keyword
                                    })
                                }),
                                index !== productKeywords.length - 1 && ", "
                            ]
                        }, "productKeywords-".concat(index));
                    })
                ]
            })
        }) : null
    });
};

// EXTERNAL MODULE: ./ui/components/SanityContentSlot.tsx + 53 modules
var SanityContentSlot = __webpack_require__(2232);
;// CONCATENATED MODULE: ./ui/components/ProductStory.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & {\n    @apply bg-puma-black-700 bg-opacity-70 py-8 px-6 md:px-10 text-puma-black max-w-full;\n  }\n\n  & h3 {\n    @apply text-xl font-bold pt-12 pb-4;\n  }\n\n  & h3:first-child {\n    @apply pt-0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  & ul {\n    text-indent: -1rem;\n    margin-left: 1rem;\n    @apply list-disc list-inside;\n  }\n\n  & li {\n    @apply py-1;\n  }\n\n  & li:last-child {\n    @apply pb-0;\n  }\n\n  & li::marker {\n    @apply text-puma-gold;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  & ul {\n    text-indent: 0;\n    margin-left: 0;\n  }\n\n  & li {\n    @apply py-4;\n    @apply border-b-1;\n    @apply border-puma-grey-light;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var productStoryStylesCommon = (0,css/* css */.iv)(_templateObject());
var productStoryStylesWithBullets = (0,css/* css */.iv)(_templateObject1(), productStoryStylesCommon);
var productStoryStylesWithoutBullets = (0,css/* css */.iv)(_templateObject2(), productStoryStylesCommon);
var ProductStory = function(param) {
    var longDescription = param.longDescription, materialComposition = param.materialComposition, careInstructions = param.careInstructions, manufacturerInfo = param.manufacturerInfo, productKeywords = param.productKeywords, additionalContentSections = param.additionalContentSections, documentId = param.documentId, slotId = param.slotId;
    var ref, ref1, ref2, ref3;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var showProductKeywordsEnabled = (0,useFeature/* useFeature */.S)("SHOW_PRODUCT_KEYWORDS");
    var removeBulletsFromListsOnPdp = (0,useFeature/* useFeature */.S)("HIDE_BULLETS_LISTS_PDP");
    var productStoryStyles = removeBulletsFromListsOnPdp ? productStoryStylesWithoutBullets : productStoryStylesWithBullets;
    var ref4 = manufacturerInfo || {}, manufacturerAddress = ref4.manufacturerAddress, countryOfOrigin = ref4.countryOfOrigin;
    var ref5 = (0,react.useMemo)(function() {
        var body = [];
        var lists = [];
        if (!constants/* isServer */.sk && longDescription) {
            var html = (0,utils_html/* parseHtml */.d)(longDescription);
            var ref;
            var nodes = (0,_to_consumable_array/* default */.Z)((ref = html === null || html === void 0 ? void 0 : html.childNodes) !== null && ref !== void 0 ? ref : []);
            while(nodes.length > 0){
                var node = nodes[0];
                var next = nodes[1];
                if ((node === null || node === void 0 ? void 0 : node.tagName) === "H3" && (next === null || next === void 0 ? void 0 : next.tagName) === "UL") {
                    lists.push("".concat(node.outerHTML).concat(next.outerHTML));
                    nodes.splice(0, 2);
                } else {
                    body.push(node.outerHTML || node.textContent || "");
                    nodes.splice(0, 1);
                }
            }
        }
        return {
            body: body,
            lists: lists
        };
    }, [
        longDescription
    ]), body = ref5.body, lists = ref5.lists;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "product-story",
        "aria-label": "Product Story",
        className: (0,css.tw)(productStoryStyles),
        children: [
            constants/* isServer */.sk ? longDescription : /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "grid gap-8 lg:gap-10 grid-cols-1 md:grid-cols-2",
                children: [
                    body.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-full",
                        children: body.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml/* SafeHtml */.T, {
                                html: item
                            }, item);
                        })
                    }),
                    lists.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml/* SafeHtml */.T, {
                            html: item
                        }, item);
                    }),
                    (materialComposition === null || materialComposition === void 0 ? void 0 : materialComposition.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "capitalize",
                                children: t("materialInformation")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: materialComposition === null || materialComposition === void 0 ? void 0 : materialComposition.map(function(material) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: material
                                    }, material);
                                })
                            })
                        ]
                    }) : null,
                    (careInstructions === null || careInstructions === void 0 ? void 0 : careInstructions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "capitalize",
                                children: t("careInstructions")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: careInstructions === null || careInstructions === void 0 ? void 0 : careInstructions.map(function(instruction) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: instruction
                                    }, instruction);
                                })
                            })
                        ]
                    }) : null,
                    (manufacturerAddress === null || manufacturerAddress === void 0 ? void 0 : (ref = manufacturerAddress.content) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        "data-test-id": "manufacturer-address-container",
                        children: [
                            (manufacturerAddress === null || manufacturerAddress === void 0 ? void 0 : manufacturerAddress.label) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "capitalize",
                                children: manufacturerAddress === null || manufacturerAddress === void 0 ? void 0 : manufacturerAddress.label
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("address", {
                                "data-test-id": "manufacturer-address-details",
                                className: "not-italic flex flex-col",
                                children: manufacturerAddress === null || manufacturerAddress === void 0 ? void 0 : (ref1 = manufacturerAddress.content) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean).map(function(content) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "py-1",
                                        children: content
                                    }, content);
                                })
                            })
                        ]
                    }) : null,
                    (countryOfOrigin === null || countryOfOrigin === void 0 ? void 0 : (ref2 = countryOfOrigin.content) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        "data-test-id": "country-of-origin-container",
                        children: [
                            (countryOfOrigin === null || countryOfOrigin === void 0 ? void 0 : countryOfOrigin.label) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "capitalize",
                                children: countryOfOrigin === null || countryOfOrigin === void 0 ? void 0 : countryOfOrigin.label
                            }) : null,
                            countryOfOrigin === null || countryOfOrigin === void 0 ? void 0 : (ref3 = countryOfOrigin.content) === null || ref3 === void 0 ? void 0 : ref3.map(function(content) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-test-id": "country-of-origin-details",
                                    children: content
                                }, content);
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                        items: additionalContentSections,
                        slotId: slotId,
                        documentId: documentId
                    })
                ]
            }),
            showProductKeywordsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStoryKeywords, {
                productKeywords: productKeywords
            })
        ]
    });
};


/***/ }),

/***/ 81985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ RemoveWishlistItemModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77480);
/* harmony import */ var _ConfirmModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57965);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53579);




var RemoveWishlistItemModal = function(props) {
    var onClickOutside = props.onClickOutside, onConfirm = props.onConfirm, product = props.product;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .qM)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ConfirmModal__WEBPACK_IMPORTED_MODULE_2__/* .ConfirmModal */ .s, {
        onClickOutside: onClickOutside,
        onConfirm: onConfirm,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-xl pr-8",
                children: t("removeWishlistItemConfirmation")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center border p-4 space-x-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_3__/* .Img */ .E, {
                            src: product.images[0].href.replace(/1000/g, "300"),
                            alt: product.images[0].alt,
                            width: 160
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-xs sm:text-sm md:text-base text-puma-black-300 pb-2",
                                        children: [
                                            "#",
                                            product.styleNumber
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "font-bold text-puma-black text-sm sm:text-lg md:text-xl leading-xxs",
                                        children: product.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-xs sm:text-sm !leading-[1em]",
                                        children: product.colorName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-bold text-puma-black text-xs sm:text-sm uppercase",
                                        children: [
                                            t("size"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-xs sm:text-sm",
                                        children: product.size.label
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 73022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20368);
/* harmony import */ var hooks_useDateFormatter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67604);





var ScheduledArrivalDate = function(param) {
    var preOrderDeliveryDate = param.preOrderDeliveryDate;
    var scheduledArrivalDateFormat = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__/* .useSiteConfig */ .N)().scheduledArrivalDateFormat;
    var dateFormatOptions = {
        date: preOrderDeliveryDate,
        format: scheduledArrivalDateFormat,
        text: "scheduledArrivalDate"
    };
    var formattedDate = (0,hooks_useDateFormatter__WEBPACK_IMPORTED_MODULE_4__/* .useDateFormatter */ .a)(dateFormatOptions);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .LiveRegion */ .LE2, {
        type: "polite",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Alert */ .bZj, {
            content: formattedDate,
            variant: "info"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScheduledArrivalDate);


/***/ }),

/***/ 98567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarRating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34209);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var utils_scroll_to__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41403);
/* harmony import */ var utils_isNumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95442);








var StarRating = function(props) {
    var rating = Number(props.rating);
    return (0,utils_isNumber__WEBPACK_IMPORTED_MODULE_4__/* .isNumber */ .h)(rating) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !props.pageAnchorId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StarRatingSRLabel, {
                rating: rating
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "presentation",
                className: "flex items-center text-puma-black-500",
                "data-test-id": props.dataTestId,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex relative",
                    children: [
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Array(5)).map(function(_, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                name: "star-empty",
                                className: "flex-shrink-0",
                                size: "2xl"
                            }, "first-rating-".concat(i));
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,twind__WEBPACK_IMPORTED_MODULE_6__.tw)("flex absolute overflow-hidden text-puma-black top-0", "w-[".concat(Math.round(rating / 5 * 100), "%]")),
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Array(5)).map(function(_, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                    name: "star-filled",
                                    className: "flex-shrink-0",
                                    size: "2xl"
                                }, "second-rating-".concat(i));
                            })
                        }),
                        props.pageAnchorId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#".concat(props.pageAnchorId),
                            className: "absolute top-0 w-[100%] h-[100%]",
                            onClick: function(e) {
                                e.preventDefault();
                                if (props.pageAnchorId) {
                                    (0,utils_scroll_to__WEBPACK_IMPORTED_MODULE_7__/* .scrollTo */ .X)(props.pageAnchorId, -100);
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StarRatingSRLabel, {
                                rating: rating
                            })
                        })
                    ]
                })
            })
        ]
    }) : null;
};
var StarRatingSRLabel = function(props) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "sr-only",
        children: [
            t("ratingAverage"),
            ": ",
            props.rating.toFixed(1),
            " / 5"
        ]
    });
};


/***/ }),

/***/ 5972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ProductVideoMuteButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);



var ProductVideoMuteButton = function(param) {
    var isMuted = param.isMuted, setIsMuted = param.setIsMuted, className = param.className;
    var handleVideoMute = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(event) {
        event.stopPropagation();
        setIsMuted(!isMuted);
    }, [
        setIsMuted,
        isMuted
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
        onClick: handleVideoMute,
        className: className,
        label: isMuted ? "muted" : "unmuted",
        icon: isMuted ? "volume-off" : "volume-on",
        mode: "icon"
    });
};


/***/ }),

/***/ 36085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S4": function() { return /* reexport */ AddToCartErrorMessage; },
  "PC": function() { return /* reexport */ ProductActions; },
  "Sl": function() { return /* reexport */ ProductBreadcrumb; },
  "mM": function() { return /* reexport */ ProductColorPicker; },
  "XJ": function() { return /* reexport */ ProductCustomizer; },
  "vI": function() { return /* reexport */ ProductDescription; },
  "nz": function() { return /* reexport */ ProductDetailsPage; },
  "pk": function() { return /* reexport */ ProductFitOptions; },
  "by": function() { return /* reexport */ ProductImageGallery; },
  "ww": function() { return /* reexport */ ProductInfo; },
  "_F": function() { return /* reexport */ ProductMessages; },
  "UT": function() { return /* reexport */ ProductPersonalise; },
  "v8": function() { return /* reexport */ ProductSizePicker; },
  "Z3": function() { return /* reexport */ ProductVariantSelectors; },
  "yI": function() { return /* reexport */ ProductWishlistButton; },
  "Pj": function() { return /* reexport */ ShippingReturnsDetails; },
  "oX": function() { return /* reexport */ ShippingReturnsMessages; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/usePdp.tsx + 1 modules
var usePdp = __webpack_require__(41316);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/AddToCartErrorMessage.tsx



var AddToCartErrorMessage = function() {
    var ref = (0,usePdp/* usePdp */.Y)(), addToCartError = ref.addToCartError, errorAnnouncementTrigger = ref.errorAnnouncementTrigger;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        hidden: !addToCartError,
        "data-test-id": "pdp-add-to-cart-error",
        children: addToCartError && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
            type: "assertive",
            role: "alert",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: addToCartError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                        name: "exclamation-outline",
                        size: "2xl"
                    })
                ]
            })
        }, errorAnnouncementTrigger)
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./hooks/useProductCustomization.tsx
var useProductCustomization = __webpack_require__(70880);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./types/analyticTypes.ts
var analyticTypes = __webpack_require__(90099);
// EXTERNAL MODULE: ./utils/extractError.ts
var extractError = __webpack_require__(4360);
;// CONCATENATED MODULE: ./utils/getStockMessageFromResultByProductId.ts
var getStockMessageFromResultByProductId = function(productId, result) {
    var stockMessage = undefined;
    var currentProduct = result === null || result === void 0 ? void 0 : result.find(function(product) {
        return product.__typename === "ProductCartItem" && (product === null || product === void 0 ? void 0 : product.product.id) === productId;
    });
    if (currentProduct) {
        stockMessage = currentProduct.stockMessageCode;
    }
    return stockMessage;
};

// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./hooks/useStickyButton.tsx
var useStickyButton = __webpack_require__(77313);
// EXTERNAL MODULE: ./ui/components/Sizes/index.ts + 9 modules
var Sizes = __webpack_require__(38913);
// EXTERNAL MODULE: ./ui/components/AddToCartButton.tsx + 3 modules
var AddToCartButton = __webpack_require__(56202);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useMainNav.tsx + 1 modules
var useMainNav = __webpack_require__(14425);
// EXTERNAL MODULE: ./utils/isAppExclusiveValidRange.ts
var isAppExclusiveValidRange = __webpack_require__(22649);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductSizePicker.tsx










var ProductSizePicker = function(param) {
    var inventory = param.inventory, isModalSizeOpen = param.isModalSizeOpen;
    var router = (0,next_router.useRouter)();
    var ref = (0,usePdp/* usePdp */.Y)(), desiredSize = ref.desiredSize, masterProduct = ref.masterProduct, variation = ref.variation, addToCartReturnCode = ref.addToCartReturnCode, isQueryStale = ref.isQueryStale, setSizeHasChanged = ref.setSizeHasChanged;
    var staticFeatures = (0,useSiteConfig/* useSiteConfig */.N)().staticFeatures;
    var useStockInfoRedesign = staticFeatures.useStockInfoRedesign;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    if (!variation) return null;
    var sizesProps = {
        sizeGroups: variation.sizeGroups,
        stale: isQueryStale,
        categoryId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.primaryCategoryId,
        productMeasurements: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productMeasurements,
        productDivision: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productDivision,
        modelMeasurementText: variation.modelMeasurementText,
        desiredSize: desiredSize,
        sizeChartId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.sizeChartId,
        productInformation: {
            id: variation.id,
            name: variation.name
        },
        onChange: function(size) {
            if (pageviewEventHasFired) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                    event_name: analytics/* AnalyticsEvents.CHOOSE_SIZE */._q.CHOOSE_SIZE,
                    event_params: {
                        item_id_ep: variation.id,
                        item_name_ep: variation.name,
                        is_gift: "false"
                    }
                });
            }
            router.replace({
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    size: size
                })
            }, "", {
                scroll: false
            });
            setSizeHasChanged(true);
        },
        isModalSizeOpen: isModalSizeOpen
    };
    if (!useStockInfoRedesign) {
        sizesProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sizesProps), {
            inventory: inventory,
            addToCartReturnCode: addToCartReturnCode
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes/* Sizes */.u8, (0,_object_spread/* default */.Z)({}, sizesProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Separator */.Z0O, {
                gap: "none",
                className: "mt-4"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/CartButtonPopup.tsx







// Timing constants
var HIDE_DELAY_MS = 5000; // 5 Seconds
var TRANSITION_MS = 300; // 300ms
var CartButtonPopup = function(param) {
    var popularityCount = param.popularityCount, productCount = param.productCount;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var staticFeatures = (0,useSiteConfig/* useSiteConfig */.N)().staticFeatures;
    var ref = (0,store/* usePopupsOpenStore */.Gd)(), isPopupOpen = ref.isPopupOpen, setPopupOpen = ref.setPopupOpen;
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var ref2 = (0,react.useState)(false), shouldRender = ref2[0], setShouldRender = ref2[1];
    var hideTimeoutRef = (0,react.useRef)();
    var unmountTimeoutRef = (0,react.useRef)();
    var rafRef = (0,react.useRef)();
    var closePopup = (0,react.useCallback)(function() {
        setPopupOpen("CartButtonPopup", false);
    }, [
        setPopupOpen
    ]);
    // Track popup open state changes
    (0,react.useEffect)(function() {
        if (isPopupOpen("CartButtonPopup")) {
            // Mount hidden first
            setShouldRender(true);
            rafRef.current = requestAnimationFrame(function() {
                setIsVisible(true);
            });
            // Schedule auto-close
            hideTimeoutRef.current = window.setTimeout(closePopup, HIDE_DELAY_MS);
        } else {
            // Start slide-out
            setIsVisible(false);
            // After transition, unmount
            unmountTimeoutRef.current = window.setTimeout(function() {
                setShouldRender(false);
            }, TRANSITION_MS);
        }
        // Cleanup on dependency change/unmount
        return function() {
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
            if (unmountTimeoutRef.current) clearTimeout(unmountTimeoutRef.current);
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
        };
    }, [
        isPopupOpen,
        closePopup
    ]);
    if (!shouldRender) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-hidden": !isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
            className: "sm:hidden fixed right-0 z-50 -bottom-px px-4 pt-6 pb-12 bg-success-90 transition-transform duration-300 ".concat(isVisible ? "-translate-y-0" : "translate-y-full"),
            gapY: "sm",
            "data-test-id": "added-to-cart-message",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    direction: "inline",
                    items: "center",
                    justify: "between",
                    className: "h-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                            direction: "row",
                            items: "center",
                            gapX: "xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                    name: "check-filled",
                                    size: "base",
                                    invert: "true",
                                    color: "base"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                    transform: "uppercase",
                                    invert: "true",
                                    size: "xs",
                                    color: "base",
                                    weight: "bold",
                                    children: t("miniCartAddedToCart")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            name: "close",
                            size: "lg",
                            invert: "true",
                            color: "base",
                            "aria-label": t("close"),
                            onClick: closePopup,
                            role: "button",
                            tabIndex: 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                    children: staticFeatures.enablePopularity && popularityCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Text */.xvT, {
                        invert: "true",
                        color: "base",
                        size: "xs",
                        transform: "uppercase",
                        children: [
                            popularityCount,
                            " + ",
                            t("popularityMessage")
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LinkCta */.NIR, {
                    label: t("miniCartViewCartAndCheckout", {
                        count: productCount
                    }),
                    href: "/cart",
                    className: "text-success-60 rounded-sm",
                    variant: "primary",
                    invert: "true",
                    size: "base",
                    onClick: function() {
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.MINICART */._q.MINICART, {
                            domevent: "button clicked",
                            domlabel: "cart page"
                        });
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                            event_name: analytics/* AnalyticsEvents.MINICART */._q.MINICART,
                            event_params: {
                                user_action: "view cart/checkout"
                            }
                        });
                    }
                }, "cart")
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductActions.tsx


































var ProductActions = function(param) {
    var mixedCartNotAllowed = param.mixedCartNotAllowed;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), addingToCart = ref3[0], setAddingToCart = ref3[1];
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref4 = (0,useCart/* useCart */.j)(), addToCart = ref4.addToCart, cart = ref4.cart;
    var ref5 = (0,useMiniCart/* useMiniCart */.lm)(), openMiniCart = ref5.openMiniCart, setMixedCartNotAllowed = ref5.setMixedCartNotAllowed;
    var router = (0,next_router.useRouter)();
    var setPopupOpen = (0,store/* usePopupsOpenStore */.Gd)().setPopupOpen;
    var siteConfig = (0,useSiteConfig/* useSiteConfig */.N)();
    // Z-index value based on country - 30 for India, 40 for other regions
    var stickyButtonZIndex = siteConfig.country === constants/* SUPPORTED_COUNTRY.IN */.bM.IN ? "z-30" : "z-40";
    var ref6 = (0,useStickyButton/* useStickyButton */.Cg)(), showStickyButton = ref6.showStickyButton, showSizesModal = ref6.showSizesModal, setShowSizesModal = ref6.setShowSizesModal;
    var ref7 = (0,useMainNav/* useMainNavContext */.QH)(), isSearchFormOpen = ref7.isSearchFormOpen, mobileMenuOpen = ref7.mobileMenuOpen;
    var ref8 = (0,react.useState)(false), showSizeGuide = ref8[0], setShowSizeGuide = ref8[1];
    var ref9 = (0,react.useState)(0), popularityCount = ref9[0], setPopularityCount = ref9[1];
    var showGiftWithPurchaseModalInMobile = (0,useFeature/* useFeature */.S)("SHOW_GIFT_WITH_PURCHASE_MODAL_IN_MOBILE");
    var isGiftWithPurchaseNewDesign = (0,useFeature/* useFeature */.S)("GIFT_WITH_PURCHASE_NEW_DESIGN");
    var productCount = (cart === null || cart === void 0 ? void 0 : cart.productCount) || 0;
    var ref10 = (0,usePdp/* usePdp */.Y)(), desiredSize = ref10.desiredSize, desiredSwatch = ref10.desiredSwatch, isAppOnly = ref10.isAppOnly, isFullLayout = ref10.isFullLayout, isSimplifiedLayout = ref10.isSimplifiedLayout, masterProduct = ref10.masterProduct, productIsOrderable = ref10.productIsOrderable, quantity = ref10.quantity, setAddToCartError = ref10.setAddToCartError, setAddToCartReturnCode = ref10.setAddToCartReturnCode, setQuantity = ref10.setQuantity, variation = ref10.variation;
    var userProductCustomization = (0,useProductCustomization/* useProductCustomization */.F)().userProductCustomization;
    var addItemsToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, sizes, selectedSize, currentUrl, ref5, productDiscovery, res, _tmp, _tmp1, _tmp2, items, _tmp3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!desiredSize) {
                        setAddToCartError(translate("pleaseSelectSize"));
                        return [
                            2
                        ];
                    }
                    setAddingToCart(true);
                    sizes = (0,products/* getSizesFromSizeGroups */.hJ)(variation.sizeGroups);
                    selectedSize = sizes.find(function(x) {
                        return x.id === desiredSize;
                    });
                    currentUrl = router.asPath;
                    productDiscovery = (ref5 = window.localStorage.getItem(constants/* REFERRER_TYPE */.cj)) !== null && ref5 !== void 0 ? ref5 : undefined;
                    _tmp = {};
                    _tmp1 = {};
                    _tmp2 = {};
                    return [
                        4,
                        addToCart((_tmp.swatch = variation.colorValue, _tmp.size = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.id, _tmp.quantity = quantity, _tmp.productId = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId, _tmp.productCustomization = userProductCustomization !== null && userProductCustomization !== void 0 ? userProductCustomization : undefined, _tmp.masterId = variation.masterId, _tmp), (0,_object_spread/* default */.Z)(_tmp1, productDiscovery && (0,_define_property/* default */.Z)(_tmp2, analyticTypes/* Dimensions.d100 */.Db.d100, productDiscovery)), // DO NOT SHOW miniCart Modal in mobile
                        !(0,media/* getIsMobile */.W)(), currentUrl)
                    ];
                case 1:
                    res = _state.sent();
                    (0,extractError/* extractCode */.N)(res) ? setAddToCartReturnCode((0,extractError/* extractCode */.N)(res)) : setAddToCartReturnCode(getStockMessageFromResultByProductId(selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId, (ref = res.data) === null || ref === void 0 ? void 0 : ref.addItemsToCart.products));
                    if ((0,extractError/* extractError */.d)(res)) {
                        setAddToCartError((0,extractError/* extractError */.d)(res));
                        return [
                            2,
                            setAddingToCart(false)
                        ];
                    }
                    items = (ref2 = (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.addItemsToCart.products) === null || ref2 === void 0 ? void 0 : ref2.filter(function(product) {
                        return product.__typename === "ProductCartItem" && (product === null || product === void 0 ? void 0 : product.product.id) === (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId);
                    });
                    if (items[0].popularityCount) setPopularityCount(items[0].popularityCount);
                    // there is some gwp items
                    if ((ref4 = (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.addItemsToCart.giftWithPurchases) === null || ref4 === void 0 ? void 0 : ref4.length) {
                        // the miniCart handles the logic to open the GWPModal
                        if ((0,media/* getIsMobile */.W)()) {
                            if (isGiftWithPurchaseNewDesign || showGiftWithPurchaseModalInMobile) {
                                openMiniCart(items); // the miniCarts redirect to open gwp modal
                            } else {
                                // in old design or no gwpInMobile -> only open popup
                                setPopupOpen("CartButtonPopup", true);
                            }
                        } else {
                            // in desktop open GWPModal
                            setMixedCartNotAllowed(mixedCartNotAllowed);
                            openMiniCart(items);
                        }
                    } else {
                        if ((0,media/* getIsMobile */.W)()) {
                            setPopupOpen("CartButtonPopup", true);
                        } else {
                            // there is no gwp items but need to open mini cart anyways
                            setMixedCartNotAllowed(mixedCartNotAllowed);
                            openMiniCart(items);
                        }
                    }
                    setAddingToCart(false);
                    _tmp3 = {};
                    (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, (_tmp3.event_name = analytics/* AnalyticsEvents.GA4EC_Stylitics */._q.GA4EC_Stylitics, _tmp3.event_params = {
                        user_action: analytics/* AnalyticsEvents.GA4_ADD_TO_CART */._q.GA4_ADD_TO_CART,
                        item_id_ep: variation === null || variation === void 0 ? void 0 : variation.id,
                        item_name_ep: variation === null || variation === void 0 ? void 0 : variation.name,
                        stylitics_outfit_id: undefined,
                        stylitics_product_id: variation === null || variation === void 0 ? void 0 : variation.id
                    }, _tmp3));
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        addToCart,
        desiredSize,
        openMiniCart,
        quantity,
        setAddToCartError,
        translate,
        userProductCustomization,
        variation,
        setAddToCartReturnCode, 
    ]);
    var selectedSwatch = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.find(function(item) {
        return item.colorValue === desiredSwatch;
    });
    var sizes = selectedSwatch ? (0,products/* getSizesFromSizeGroups */.hJ)(selectedSwatch.sizeGroups) : [];
    var selectedSize = sizes.find(function(item) {
        return item.id === desiredSize;
    });
    (0,react.useEffect)(function() {
        if (desiredSize || variation) {
            setQuantity(1);
        }
    }, [
        setQuantity,
        desiredSize,
        variation
    ]);
    (0,react.useEffect)(function() {
        if (desiredSize && showSizesModal) {
            setShowSizesModal(false);
            addItemsToCart();
        }
    }, [
        addItemsToCart,
        desiredSize,
        setShowSizesModal,
        showSizesModal
    ]);
    if (!productIsOrderable) return null;
    var desiredSizeIsOrderable = desiredSize === undefined || ((ref = sizes.find(function(size) {
        return size.id === desiredSize;
    })) === null || ref === void 0 ? void 0 : ref.orderable);
    // Determine visibility of the sticky action container
    var isStickyVisible = showStickyButton && !(0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppOnly, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeFrom, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeTo);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        direction: "inline",
        gap: "sm",
        children: [
            isFullLayout && !(0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppOnly, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeFrom, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeTo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductWishlistButton, {
                    disabled: !desiredSizeIsOrderable,
                    quantity: quantity
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                gap: "sm",
                className: (0,twind.tw)({
                    "flex-row-reverse": isSimplifiedLayout
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* AddToCartButton */.a, {
                        disabled: !desiredSizeIsOrderable,
                        isAppExclusive: variation === null || variation === void 0 ? void 0 : variation.isAppExclusive,
                        loading: addingToCart,
                        onAddToCart: addItemsToCart,
                        presale: variation === null || variation === void 0 ? void 0 : (ref1 = variation.displayOutOfStock) === null || ref1 === void 0 ? void 0 : ref1.presale,
                        size: "lg",
                        appOnlyDateTimeFrom: variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeFrom,
                        appOnlyDateTimeTo: variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeTo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Container */.W20, {
                        "aria-hidden": !isStickyVisible,
                        className: "sm:hidden fixed bottom-0 right-0 w-full bg-white transition ".concat(stickyButtonZIndex, " duration-[1500ms] ").concat(isStickyVisible ? "-translate-y-0" : "translate-y-full", " ").concat(!(showStickyButton || showSizeGuide || showSizesModal) ? "hidden" : ""),
                        children: [
                            showSizeGuide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes/* SizeGuide */.$7, {
                                categoryId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.primaryCategoryId,
                                productMeasurements: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productMeasurements,
                                onClickOutside: function() {
                                    setShowSizeGuide(false);
                                    setShowSizesModal(true);
                                },
                                productDivision: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productDivision
                            }),
                            showSizesModal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                                variant: "dark",
                                onClickOutside: function() {
                                    setShowSizesModal(false);
                                },
                                className: "w-full animate-fade-in w-full rounded-none fixed bottom-0",
                                containerClassName: "p-0",
                                dataTestId: "size-modal",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                        direction: "row",
                                        className: "justify-between items-center px-6 py-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                                                size: "sm",
                                                children: translate("pleaseSelectSize")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                                                "data-test-id": "close-sticky-addtocart",
                                                onClick: function() {
                                                    return setShowSizesModal(false);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                        className: "px-6 pb-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return setShowSizeGuide(true);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                                    direction: "row",
                                                    items: "center",
                                                    gap: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                                                            size: "sm",
                                                            weight: "bold",
                                                            dataTestId: "size-guide-button",
                                                            children: translate("sizeGuide")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                            name: "ruler",
                                                            size: "2xl"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFitOptions, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSizePicker, {
                                                isModalSizeOpen: true
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: !isSearchFormOpen && !mobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                                    className: "px-4 py-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                        label: (variation === null || variation === void 0 ? void 0 : (ref2 = variation.displayOutOfStock) === null || ref2 === void 0 ? void 0 : ref2.presale) ? translate("preOrder") : translate("addToCart"),
                                        dataTestId: "add-to-cart-sticky-button",
                                        variant: "primary",
                                        className: "w-full",
                                        size: "lg",
                                        disabled: !desiredSizeIsOrderable,
                                        loading: addingToCart,
                                        onClick: function() {
                                            if (sizes.length === 1 || selectedSize) return addItemsToCart();
                                            setShowSizesModal(true);
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButtonPopup, {
                popularityCount: popularityCount,
                productCount: productCount
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./utils/breadcrumbRedirects.ts + 1 modules
var breadcrumbRedirects = __webpack_require__(5567);
// EXTERNAL MODULE: ./ui/components/Breadcrumb.tsx + 1 modules
var Breadcrumb = __webpack_require__(37404);
// EXTERNAL MODULE: ./ui/components/Skeleton.tsx
var Skeleton = __webpack_require__(98463);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ./hooks/useIsCrawler.tsx
var useIsCrawler = __webpack_require__(32239);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductBreadcrumb.tsx















var ProductBreadcrumb = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,usePdp/* usePdp */.Y)(), masterProduct = ref1.masterProduct, referrerCategoryId = ref1.referrerCategoryId;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var isCustomizingProduct = (0,useProductCustomization/* useProductCustomization */.F)().isCustomizingProduct;
    var variableId = referrerCategoryId || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.primaryCategoryId) || "";
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCategoryByIdQuery */.Z$c)({
        variables: {
            id: variableId
        },
        pause: !variableId || isServer && !isCrawler
    }), 1), categoryByIdQuery = ref2[0];
    var categoryById = (ref = categoryByIdQuery.data) === null || ref === void 0 ? void 0 : ref.categoryById;
    // Generate the breadcrumb path
    var path = (0,react.useMemo)(function() {
        var productLink = "pd/".concat(router.query.model, "/").concat(router.query.id);
        var isPersonalizingProduct = router.pathname.indexOf("personalise") > 0;
        if (masterProduct && categoryById) {
            // Use the centralized function for product breadcrumbs
            return (0,breadcrumbRedirects/* createProductBreadcrumbLinks */.A2)({
                categoryById: categoryById,
                productName: masterProduct.name,
                productLink: productLink,
                isCustomizing: isCustomizingProduct,
                customizeUrl: router.query.model,
                customizeLabel: translate("customize"),
                isPersonalizing: isPersonalizingProduct,
                personalizeLabel: translate("personaliseBreadcrumb")
            });
        } else {
            return [
                {
                    label: "home",
                    url: ""
                }
            ];
        }
    }, [
        router.query.model,
        router.query.id,
        router.pathname,
        isCustomizingProduct,
        translate,
        categoryById,
        masterProduct, 
    ]);
    var everyVariationHasSizes = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.every(function(variation) {
        var retypedVariation = variation;
        var sizes = (0,products/* getSizesFromSizeGroups */.hJ)(retypedVariation === null || retypedVariation === void 0 ? void 0 : retypedVariation.sizeGroups);
        return sizes.length > 0;
    });
    // This is because "isQueryStale" is not reliable. This is fixed in later urql but we cannot upgrade yet.
    if (!masterProduct || !isCrawler && !everyVariationHasSizes) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Loading breadcrumbs"
                }),
                (0,_to_consumable_array/* default */.Z)(Array(3)).map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        className: "w-20 h-[20px]",
                        delay: "".concat((i + 1) * 100, "ms")
                    }, i);
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* Breadcrumb */.a, {
        path: path,
        isPdpFromPlp: !!referrerCategoryId
    });
};

// EXTERNAL MODULE: ./ui/components/Styles.tsx
var Styles = __webpack_require__(87260);
// EXTERNAL MODULE: ./utils/ga4Items.ts
var ga4Items = __webpack_require__(54093);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductColorPicker.tsx
















var ProductColorPicker = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,usePdp/* usePdp */.Y)(), desiredSwatch = ref1.desiredSwatch, masterProduct = ref1.masterProduct, productIsOrderable = ref1.productIsOrderable, variation = ref1.variation;
    var sizes = variation ? (0,products/* getSizesFromSizeGroups */.hJ)(variation.sizeGroups) : [];
    var variations = (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations) || [];
    var staticFeatures = (0,useSiteConfig/* useSiteConfig */.N)().staticFeatures;
    var isPNARegion = staticFeatures.isPNARegion;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var isStyliticsEnabled = (0,useFeature/* useFeature */.S)("OUTFITS_ENABLED");
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                gap: "xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                        asChild: true,
                        size: "sm",
                        weight: "bold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: translate("color")
                        })
                    }),
                    (variation === null || variation === void 0 ? void 0 : variation.colorName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                        asChild: true,
                        size: "xxxs",
                        weight: "normal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            children: [
                                variation === null || variation === void 0 ? void 0 : variation.colorName,
                                " ",
                                !productIsOrderable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "sr-only",
                                    children: [
                                        ":",
                                        " ",
                                        (variation === null || variation === void 0 ? void 0 : (ref = variation.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.displayValue) || translate("soldOut")
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        className: "mt-2 w-24 h-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styles/* Styles */.z, {
                desiredSwatch: desiredSwatch,
                variations: variations,
                onChange: function(swatch) {
                    var attributeValue = variations === null || variations === void 0 ? void 0 : variations.find(function(variation) {
                        return (variation === null || variation === void 0 ? void 0 : variation.colorValue) === swatch;
                    });
                    if (pageviewEventHasFired) {
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                            event_name: analytics/* AnalyticsEvents.CHANGE_COLOR */._q.CHANGE_COLOR,
                            event_params: {
                                item_id_ep: variation === null || variation === void 0 ? void 0 : variation.id,
                                item_name_ep: variation === null || variation === void 0 ? void 0 : variation.name,
                                color_code_ep: "a".concat(attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.colorValue),
                                style_number_ep: attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.masterId,
                                is_gift: "false"
                            }
                        });
                        if (isPNARegion && isStyliticsEnabled) {
                            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                                event_name: analytics/* AnalyticsEvents.GA4EC_Stylitics */._q.GA4EC_Stylitics,
                                event_params: {
                                    user_action: analytics/* AnalyticsEvents.CHANGE_COLOR */._q.CHANGE_COLOR,
                                    item_id_ep: attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.id,
                                    item_name_ep: attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.name,
                                    stylitics_outfit_id: undefined,
                                    stylitics_product_id: attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.id
                                }
                            });
                        }
                    }
                    var id = "".concat(attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.masterId, "_").concat(attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.colorValue);
                    //If already in the map, do nothing
                    var currentGa4Item = (0,ga4Items/* getGa4Item */.Vr)(id);
                    if (currentGa4Item) {} else {
                        //In the Ga4ItemsMap I check if there is an relative entry (has the same masterProductId).
                        //If that is the case, add an entry with the same value but different key.
                        var lastRelativeEntry = (0,ga4Items/* getLastRelativeEntry */.nL)(attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.masterId);
                        if (lastRelativeEntry) {
                            var _lastRelativeEntry = (0,_sliced_to_array/* default */.Z)(lastRelativeEntry, 2), _ = _lastRelativeEntry[0], lastValue = _lastRelativeEntry[1];
                            var newGa4Item = (0,_object_spread/* default */.Z)({}, lastValue);
                            if (newGa4Item.cart) delete newGa4Item.cart;
                            (0,ga4Items/* setGa4ItemInMap */.HH)(id, newGa4Item, true);
                        }
                    }
                    router.replace({
                        query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                            swatch: swatch
                        })
                    }, "", {
                        scroll: false
                    });
                },
                isHydrating: sizes.length === 0,
                colors: (ref2 = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.colors) !== null && ref2 !== void 0 ? ref2 : undefined
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/elements/Button.tsx + 1 modules
var Button = __webpack_require__(70868);
;// CONCATENATED MODULE: ./ui/components/CustomizeProductSwitch.tsx



// Displayed on the PDP's Product Details right menu
var CustomizeProductSwitch = function(param) {
    var productCustomization = param.productCustomization, onClick = param.onClick, onClear = param.onClear;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: productCustomization && productCustomization.numberText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        t("number"),
                                        ": ",
                                        productCustomization.numberText
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        t("name"),
                                        ": ",
                                        productCustomization.nameText
                                    ]
                                })
                            ]
                        }),
                        productCustomization.imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: productCustomization.imageUrl,
                            className: "max-w-16"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: "w-full",
                    outlined: true,
                    onClick: onClear,
                    children: t("clear") + " " + t("customization")
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            className: "w-full",
            outlined: true,
            onClick: onClick,
            children: t("customize")
        })
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductCustomizer.tsx







var ProductCustomizer = function() {
    var ref;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var variation = (0,usePdp/* usePdp */.Y)().variation;
    var customizationEnabled = (0,useFeature/* useFeature */.S)("MY_CUSTOMIZER");
    var ref1 = (0,useProductCustomization/* useProductCustomization */.F)(), userProductCustomization = ref1.userProductCustomization, clearUserProductCustomization = ref1.clearUserProductCustomization, startCustomization = ref1.startCustomization;
    var startProductCustomization = (0,react.useCallback)(function() {
        return startCustomization();
    }, [
        startCustomization
    ]);
    if (!(customizationEnabled && (variation === null || variation === void 0 ? void 0 : (ref = variation.myCustomizer) === null || ref === void 0 ? void 0 : ref.enabled))) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold text-xl",
                        children: translate("customization")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeProductSwitch, {
                        productCustomization: userProductCustomization,
                        onClick: startProductCustomization,
                        onClear: function() {
                            clearUserProductCustomization();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
        ]
    });
};

// EXTERNAL MODULE: ./ui/components/ManagedHeading.tsx
var ManagedHeading = __webpack_require__(93512);
// EXTERNAL MODULE: ./utils/scroll-to.ts
var scroll_to = __webpack_require__(41403);
// EXTERNAL MODULE: ./ui/elements/SafeHtml.tsx
var SafeHtml = __webpack_require__(99671);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductDescription.tsx









var ProductDescription = function() {
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref = (0,usePdp/* usePdp */.Y)(), masterProduct = ref.masterProduct, variation = ref.variation;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    if (!(masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.description)) return null;
    var triggerEventAndScrollTo = function() {
        (0,scroll_to/* scrollTo */.X)("product-story", -70);
        if (pageviewEventHasFired && variation) (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
            event_name: analytics/* AnalyticsEvents.MORE_INFORMATION */._q.MORE_INFORMATION,
            event_params: {
                item_id_ep: variation === null || variation === void 0 ? void 0 : variation.id,
                item_name_ep: variation === null || variation === void 0 ? void 0 : variation.name,
                color_code_ep: (0,analytics/* addPrefixToAnalyticProp */.lL)(variation === null || variation === void 0 ? void 0 : variation.colorValue),
                style_number_ep: variation === null || variation === void 0 ? void 0 : variation.styleNumber
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        gap: "sm",
        "data-test-id": "pdp-product-description",
        className: "pb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                asChild: true,
                size: "sm",
                weight: "bold",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                    tag: "h2",
                    children: translate("description")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml/* SafeHtml */.T, {
                    // original css that added ellipsis, but created an overflow bug in Safari
                    // add back at risk of a regression.
                    // style={{
                    //   display: '-webkit-box',
                    //   WebkitLineClamp: 2,
                    //   WebkitBoxOrient: 'vertical',
                    //   overflow: 'hidden',
                    // }}
                    // ellipsis does not work with this method but everything else looks good.
                    style: {
                        lineHeight: "1.5em",
                        height: "3em",
                        overflow: "hidden",
                        width: "100%",
                        textOverflow: "ellipsis"
                    },
                    html: (variation === null || variation === void 0 ? void 0 : variation.description) || masterProduct.description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "list-disc list-inside",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                translate("style"),
                                ": ",
                                variation === null || variation === void 0 ? void 0 : variation.id
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                translate("color"),
                                ": ",
                                variation === null || variation === void 0 ? void 0 : variation.colorName
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonUnderline */.xnB, {
                dataTestId: "read-more-btn",
                transform: "uppercase",
                size: "sm",
                className: "mt-2",
                onClick: function() {
                    return triggerEventAndScrollTo();
                },
                label: translate("additionalInfo")
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useInventory.ts
var useInventory = __webpack_require__(55587);
;// CONCATENATED MODULE: ./utils/mixedCartValidations.ts

var sendMixedCartErrorMessage = function(cart, variation) {
    var ref, ref1;
    var emptyCart = cart === null || (cart === null || cart === void 0 ? void 0 : cart.productCount) === 0;
    if (emptyCart) return;
    if (cart === null || cart === void 0 ? void 0 : cart.isMixedCartAllowed) return;
    var isPreSaleProduct = (variation === null || variation === void 0 ? void 0 : (ref = variation.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.presale) && (cart === null || cart === void 0 ? void 0 : cart.basketInStockStatus) !== constants/* BASKET_STOCK_STATUS.PREORDER */.cU.PREORDER || (cart === null || cart === void 0 ? void 0 : cart.basketInStockStatus) === constants/* BASKET_STOCK_STATUS.MIXED */.cU.MIXED;
    var isNormalProduct = !(variation === null || variation === void 0 ? void 0 : (ref1 = variation.displayOutOfStock) === null || ref1 === void 0 ? void 0 : ref1.presale) && (cart === null || cart === void 0 ? void 0 : cart.basketInStockStatus) === constants/* BASKET_STOCK_STATUS.PREORDER */.cU.PREORDER || (cart === null || cart === void 0 ? void 0 : cart.basketInStockStatus) === constants/* BASKET_STOCK_STATUS.MIXED */.cU.MIXED;
    return isPreSaleProduct || isNormalProduct;
};

// EXTERNAL MODULE: ./hooks/useSimpleCart.tsx
var useSimpleCart = __webpack_require__(85914);
// EXTERNAL MODULE: ./utils/deepEqual.ts
var deepEqual = __webpack_require__(48604);
;// CONCATENATED MODULE: ./hooks/useItemViewEvent.ts






var useItemViewEvent = function(param) {
    var itemListId = param.itemListId, itemListName = param.itemListName, itemIdEp = param.itemIdEp, itemNameEp = param.itemNameEp, imageType = param.imageType, imageNumber = param.imageNumber, value = param.value, item = param.item, currency = param.currency, desiredSize = param.desiredSize, selectedSize = param.selectedSize;
    var previousItemRef = (0,react.useRef)();
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    (0,react.useEffect)(function() {
        var hasAlreadyExecuted = (0,deepEqual/* areDeepEqual */.A)(previousItemRef.current, item);
        var hasCategory = (item === null || item === void 0 ? void 0 : item.item_category) !== null;
        if (item && hasCategory && !hasAlreadyExecuted && pageviewEventHasFired && (!desiredSize || selectedSize)) {
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4EC_ItemView */._q.GA4EC_ItemView, {
                event_name: analytics/* AnalyticsEvents.VIEW_ITEM */._q.VIEW_ITEM,
                ecommerce: {
                    item_list_id: itemListId,
                    item_list_name: itemListName,
                    item_id_ep: itemIdEp,
                    item_name_ep: itemNameEp,
                    value: value,
                    image_type: imageType,
                    image_number: imageNumber,
                    items: [
                        !selectedSize ? item : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            item_variant: selectedSize.productId,
                            size: (0,analytics/* addPrefixToAnalyticProp */.lL)(selectedSize.label)
                        }), 
                    ],
                    currency: currency
                }
            });
            previousItemRef.current = item;
        }
    }, [
        itemListId,
        itemListName,
        itemIdEp,
        itemNameEp,
        imageType,
        imageNumber,
        value,
        item,
        pageviewEventHasFired,
        currency,
        desiredSize,
        selectedSize, 
    ]);
};

// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./hooks/useSticky.tsx
var useSticky = __webpack_require__(8261);
;// CONCATENATED MODULE: ./ui/components/ProductCustomizers.tsx



var MyCustomizer = function(param) {
    var variation = param.variation, onProductCustomized = param.onProductCustomized;
    var ref, ref1;
    var env = (0,useSiteConfig/* useSiteConfig */.N)().env;
    var MC_BASEURL = env.myCustomizerDomain;
    var MC_SHOPID = env.myCustomizerShopId;
    var id = ((ref = variation.myCustomizer) === null || ref === void 0 ? void 0 : ref.iframeID) || "myCustomizer";
    var startPoint = (ref1 = variation.myCustomizer) === null || ref1 === void 0 ? void 0 : ref1.startPoint;
    var URL = "".concat(MC_BASEURL, "/customize/startingpoint/").concat(startPoint, "?shopid=").concat(MC_SHOPID, "&lang=en");
    (0,react.useEffect)(function() {
        var callback = function(event) {
            if (event.data.eventName === "mczrAddToCart" && event.origin === MC_BASEURL) {
                onProductCustomized(event.data.detail);
            }
        };
        window.addEventListener("message", callback);
        return function() {
            return window.removeEventListener("message", callback);
        };
    }, [
        MC_BASEURL,
        onProductCustomized
    ]);
    // NOTE: Using a custom color to match the BG of the iframe (once loaded), reducing flashes / whitespace
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-[#F7F7F7]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: URL,
            id: id,
            width: "100%",
            height: "500"
        })
    });
};

// EXTERNAL MODULE: ./ui/components/SanityContentSlot.tsx + 53 modules
var SanityContentSlot = __webpack_require__(2232);
// EXTERNAL MODULE: ./ui/components/ScheduledArrivalDate.tsx
var ScheduledArrivalDate = __webpack_require__(73022);
// EXTERNAL MODULE: ./ui/components/MixedCartErrorMessage.tsx
var MixedCartErrorMessage = __webpack_require__(56620);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/PdpSimplifiedLayout.tsx











var PincodeServiceabilityCheck = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5455).then(__webpack_require__.bind(__webpack_require__, 95455));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95455)
            ];
        }
    },
    ssr: false
});
var PdpSimplifiedLayout = function(param) {
    var masterProduct = param.masterProduct, variation = param.variation, content = param.content, mixedCartNotAllowed = param.mixedCartNotAllowed, sizeHasChanged = param.sizeHasChanged;
    var ref, ref1, ref2;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref3 = (0,useSticky/* useSticky */.A)(3), stickyRef = ref3.stickyRef, stickyTop = ref3.stickyTop;
    var ref4 = (0,useProductCustomization/* useProductCustomization */.F)(), customizationReceived = ref4.customizationReceived, isCustomizingProduct = ref4.isCustomizingProduct;
    var isMasterSoldOutWithRecommender = masterProduct === null || masterProduct === void 0 ? void 0 : (ref = masterProduct.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.soldoutWithRecommender;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBreadcrumb, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                asChild: true,
                gap: {
                    _: "sm",
                    md: "lg"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    "aria-labelledby": "pdp-product-title",
                    className: "mobile:mt-4 tablet:mt-6 desktop:mt-8",
                    children: variation && isCustomizingProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MyCustomizer, {
                        variation: variation,
                        onProductCustomized: customizationReceived
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Grid */.rjZ, {
                        columns: {
                            _: "1",
                            md: "8",
                            lg: "12"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageGallery, {
                                className: "grid-cols-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                "aria-label": t("productInfo"),
                                className: "order-1 h-full md:col-span-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                    ref: stickyRef,
                                    gap: "base",
                                    className: "md:pt-3 md:sticky md:top-[".concat(stickyTop, "px]"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfo, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariantSelectors, {}),
                                        !isMasterSoldOutWithRecommender && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartErrorMessage, {}),
                                                sizeHasChanged && /*#__PURE__*/ (0,jsx_runtime.jsx)(MixedCartErrorMessage/* MixedCartErrorMessage */.U, {
                                                    mixedCartNotAllowed: mixedCartNotAllowed
                                                }),
                                                (variation === null || variation === void 0 ? void 0 : (ref1 = variation.displayOutOfStock) === null || ref1 === void 0 ? void 0 : ref1.presale) && (variation === null || variation === void 0 ? void 0 : (ref2 = variation.displayOutOfStock) === null || ref2 === void 0 ? void 0 : ref2.validTo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduledArrivalDate/* default */.Z, {
                                                    preOrderDeliveryDate: variation.displayOutOfStock.validTo
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductActions, {
                                                    mixedCartNotAllowed: mixedCartNotAllowed
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PincodeServiceabilityCheck, {})
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                items: content === null || content === void 0 ? void 0 : content.belowProductGoogleShopping,
                slotId: "belowProductGoogleShopping",
                documentId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/components/PixleeProductWidget.tsx
var PixleeProductWidget = __webpack_require__(6411);
// EXTERNAL MODULE: ./ui/components/ProductStory.tsx + 1 modules
var ProductStory = __webpack_require__(71759);
// EXTERNAL MODULE: ./hooks/useInView.ts
var useInView = __webpack_require__(50641);
// EXTERNAL MODULE: ./utils/constructCategoryPath.ts
var constructCategoryPath = __webpack_require__(97729);
;// CONCATENATED MODULE: ./ui/components/ExploreCollectionCta.tsx









var ExploreCollectionCta = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var localizeUrlPath = (0,useSiteConfig/* useSiteConfig */.N)().localizeUrlPath;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var _masterProduct;
    var ref1 = (_masterProduct = props.masterProduct) !== null && _masterProduct !== void 0 ? _masterProduct : {}, defaultCategoryId = ref1.primaryCategoryId, showExploreCollectionCTA = ref1.showExploreCollectionCTA, exploreMoreCTALabel = ref1.exploreMoreCTALabel, targetCategoryId = ref1.exploreMoreCTATargetCategoryID;
    var categoryId = targetCategoryId !== null && targetCategoryId !== void 0 ? targetCategoryId : defaultCategoryId;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCategoryByIdQuery */.Z$c)({
        variables: {
            id: categoryId
        },
        pause: !categoryId || constants/* isServer */.sk
    }), 1), categoryByIdQuery = ref2[0];
    if (!showExploreCollectionCTA || !categoryId) return null;
    var categoryById = (ref = categoryByIdQuery.data) === null || ref === void 0 ? void 0 : ref.categoryById;
    if (!categoryById) return null;
    var categoryUrls = (0,constructCategoryPath/* constructCategoryPath */.h)(categoryById);
    var url = categoryUrls[categoryUrls.length - 1].url;
    var defaultExploreMoreLabel = t("exploreCollection");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rUS, {
        dataTestId: "explore-this-collection-cta",
        href: isCrawler ? localizeUrlPath(url, true) : url,
        label: exploreMoreCTALabel !== null && exploreMoreCTALabel !== void 0 ? exploreMoreCTALabel : defaultExploreMoreLabel,
        variant: "secondary",
        size: "lg"
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/PdpFullLayout.tsx






















var KlarnaText = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7621).then(__webpack_require__.bind(__webpack_require__, 27621));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27621)
            ];
        }
    },
    ssr: false
});
var PdpFullLayout_PincodeServiceabilityCheck = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5455).then(__webpack_require__.bind(__webpack_require__, 95455));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95455)
            ];
        }
    },
    ssr: false
});
var ReviewsActions = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8330).then(__webpack_require__.bind(__webpack_require__, 98330));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98330)
            ];
        }
    }
});
var PdpFullLayout = function(param) {
    var masterProduct = param.masterProduct, variation = param.variation, inventory = param.inventory, content = param.content, productScore = param.productScore, isAppOnly = param.isAppOnly, mixedCartNotAllowed = param.mixedCartNotAllowed, sizeHasChanged = param.sizeHasChanged;
    var ref, ref1, ref2;
    var reviewsEnabled = (0,useFeature/* useFeature */.S)("RATINGS_AND_REVIEWS");
    var returnsDisabled = (0,useFeature/* useFeature */.S)("PDP_DISABLE_RETURNS");
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref3 = (0,useSticky/* useSticky */.A)(3), stickyRef = ref3.stickyRef, stickyTop = ref3.stickyTop;
    var freeShippingThreshold = (0,useSiteConfig/* useSiteConfig */.N)().freeShippingThreshold;
    var ref4 = (0,useProductCustomization/* useProductCustomization */.F)(), customizationReceived = ref4.customizationReceived, isCustomizingProduct = ref4.isCustomizingProduct;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useInView/* useInView */.Y)(), 2), pixleeInViewRef = ref5[0], pixleeInView = ref5[1];
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBreadcrumb, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                asChild: true,
                gap: {
                    _: "sm",
                    sm: "lg"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-labelledby": "pdp-product-title",
                    className: "mobile:mt-4 tablet:mt-6 desktop:mt-8",
                    children: [
                        variation && isCustomizingProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MyCustomizer, {
                            variation: variation,
                            onProductCustomized: customizationReceived
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Grid */.rjZ, {
                            columns: {
                                _: "1",
                                md: "8",
                                lg: "12"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageGallery, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    "aria-label": t("productInfo"),
                                    className: "order-1 h-full md:col-span-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                        ref: stickyRef,
                                        gap: "base",
                                        className: "md:pt-3 md:sticky md:top-[".concat(stickyTop, "px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfo, {
                                                rating: productScore === null || productScore === void 0 ? void 0 : productScore.rating,
                                                reviewCount: productScore === null || productScore === void 0 ? void 0 : productScore.amount
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KlarnaText, {
                                                amount: (variation === null || variation === void 0 ? void 0 : variation.salePrice) || (variation === null || variation === void 0 ? void 0 : variation.price)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariantSelectors, {
                                                inventory: inventory === null || inventory === void 0 ? void 0 : (ref = inventory.data) === null || ref === void 0 ? void 0 : ref.inventory.quantity
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartErrorMessage, {}),
                                            sizeHasChanged && /*#__PURE__*/ (0,jsx_runtime.jsx)(MixedCartErrorMessage/* MixedCartErrorMessage */.U, {
                                                mixedCartNotAllowed: mixedCartNotAllowed
                                            }),
                                            (variation === null || variation === void 0 ? void 0 : (ref1 = variation.displayOutOfStock) === null || ref1 === void 0 ? void 0 : ref1.presale) && (variation === null || variation === void 0 ? void 0 : (ref2 = variation.displayOutOfStock) === null || ref2 === void 0 ? void 0 : ref2.validTo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScheduledArrivalDate/* default */.Z, {
                                                preOrderDeliveryDate: variation.displayOutOfStock.validTo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductActions, {
                                                mixedCartNotAllowed: mixedCartNotAllowed
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExploreCollectionCta, {
                                                masterProduct: masterProduct
                                            }),
                                            !(0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppOnly, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeFrom, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeTo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingReturnsMessages, {
                                                freeShippingThreshold: freeShippingThreshold,
                                                variation: variation,
                                                returnsDisabled: returnsDisabled
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpFullLayout_PincodeServiceabilityCheck, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDescription, {}),
                                            reviewsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsActions, {
                                                productId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id,
                                                variationId: variation === null || variation === void 0 ? void 0 : variation.id,
                                                productName: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name,
                                                rating: productScore === null || productScore === void 0 ? void 0 : productScore.rating,
                                                amount: productScore === null || productScore === void 0 ? void 0 : productScore.amount,
                                                pageviewEventHasFired: pageviewEventHasFired
                                            }),
                                            !(0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppOnly, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeFrom, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeTo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingReturnsDetails, {
                                                freeShippingThreshold: freeShippingThreshold,
                                                callout: content === null || content === void 0 ? void 0 : content.pdpCallout
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                            items: content === null || content === void 0 ? void 0 : content.aboveProductStory,
                            slotId: "aboveProductStory",
                            documentId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id
                        }),
                        (variation === null || variation === void 0 ? void 0 : variation.productStory) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStory/* ProductStory */.F, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variation.productStory), {
                            additionalContentSections: content === null || content === void 0 ? void 0 : content.ProductStoryAdditionalContentSlot,
                            documentId: content === null || content === void 0 ? void 0 : content._id,
                            slotId: "ProductStoryAdditionalContentSlot"
                        })),
                        (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: pixleeInViewRef,
                            children: pixleeInView && /*#__PURE__*/ (0,jsx_runtime.jsx)(PixleeProductWidget/* PixleeProductWidget */.H, {
                                skuId: masterProduct.id
                            }, variation === null || variation === void 0 ? void 0 : variation.id)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                            items: content === null || content === void 0 ? void 0 : content.belowProductStory,
                            slotId: "belowProductStory",
                            documentId: content === null || content === void 0 ? void 0 : content._id
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/content/Emplifi/StarsBelowPDPTitle.tsx


var EmplifiStarsBelowPDPTitle = function(param) {
    var sku = param.sku;
    var staticFeatures = (0,useSiteConfig/* useSiteConfig */.N)().staticFeatures;
    if (!staticFeatures.isPNARegion || !sku) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "tt-teaser-widget"
    });
};

// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ./ui/components/RecommendationTile.tsx
var RecommendationTile = __webpack_require__(43477);
// EXTERNAL MODULE: ./ui/components/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(91622);
// EXTERNAL MODULE: ./utils/isNotNullish.ts
var isNotNullish = __webpack_require__(50597);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductRecommendations.tsx











var MAX_RECOMMENDATIONS = 4;
var ProductRecommendations = function(param) {
    var recommender = param.recommender, masterProduct = param.masterProduct, content = param.content;
    var ref, ref1, ref2, ref3;
    var isCrawler = (0,useIsCrawler/* useIsCrawler */.i)();
    var recommenderType = content === null || content === void 0 ? void 0 : (ref = content.soldOutRecommender) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.type;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRecommendationsWithDetailsQuery */.MA5)({
        variables: {
            pageType: recommenderType,
            ids: [
                masterProduct.id,
                masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.primaryCategoryId
            ].filter(isNotNullish/* isNotNullish */.l)
        },
        pause: isServer && !isCrawler || !recommenderType
    }), 1), result = ref4[0];
    if (!recommender) return null;
    var productRecommender = recommender[0];
    var recoType = productRecommender === null || productRecommender === void 0 ? void 0 : productRecommender.__typename;
    if (recoType === "ProductRecommender" && !recommenderType) return null;
    var products = [];
    var recommendations = (ref2 = result.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.recommendationsWithDetails) === null || ref3 === void 0 ? void 0 : ref3.recommendations;
    if (recoType === "ProductRecommender") {
        if (recommendations) {
            products = (recommendations || []).reduce(function(acc, curr) {
                if (curr === null || curr === void 0 ? void 0 : curr.variantProduct) {
                    return (0,_to_consumable_array/* default */.Z)(acc).concat([
                        curr.variantProduct
                    ]);
                }
                return acc;
            }, []);
        }
    } else if (recoType === "ProductCarousel") {
        products = productRecommender === null || productRecommender === void 0 ? void 0 : productRecommender.products;
    }
    if (result.fetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* LoadingSpinner */.T, {
            className: "w-40 h-40 my-40 mx-auto"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            (productRecommender === null || productRecommender === void 0 ? void 0 : productRecommender.header) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                tag: "h1",
                dataTestId: "recommender-header",
                className: (0,css.tw)([
                    (0,css/* apply */.nn)("uppercase font-bold text-xl mobile:text-lg mb-1 pt-6"),
                    !(productRecommender === null || productRecommender === void 0 ? void 0 : productRecommender.copy) && "mb-6", 
                ]),
                children: productRecommender === null || productRecommender === void 0 ? void 0 : productRecommender.header
            }),
            (productRecommender === null || productRecommender === void 0 ? void 0 : productRecommender.copy) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-base mb-6",
                children: productRecommender === null || productRecommender === void 0 ? void 0 : productRecommender.copy
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,css.tw)("grid gap-x-4 gap-y-8 transition-opacity duration-700", "grid-cols-2"),
                children: products.slice(0, MAX_RECOMMENDATIONS).map(function(product) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationTile/* RecommendationTile */.I, {
                        containerClassName: "h-full justify-between",
                        dataTestId: "carousel-product-item",
                        linkClassName: "text-center text-xs",
                        product: product,
                        productInfoConfig: {
                            priceContainerClassName: "hidden"
                        }
                    }, product.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/SoldOutBanner.tsx



var SoldOutBanner = function(param) {
    var message = param.message;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Card */.Zbd, {
        variant: "fill",
        insetY: "sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
            asChild: true,
            weight: "bold",
            className: "cursor-not-allowed text-center",
            size: "base",
            transform: "uppercase",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                "data-test-id": "product-sold-out",
                children: message || t("soldOut")
            })
        })
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/PdpSoldoutWithRecommenderLayout.tsx














var PdpSoldoutWithRecommenderLayout = function(param) {
    var masterProduct = param.masterProduct, variation = param.variation, content = param.content;
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref1 = (0,useSticky/* useSticky */.A)(3), stickyRef = ref1.stickyRef, stickyTop = ref1.stickyTop;
    var ref2 = (0,useSiteConfig/* useSiteConfig */.N)(), isPNARegion = ref2.staticFeatures.isPNARegion;
    var recommender = content === null || content === void 0 ? void 0 : content.soldOutRecommender;
    var isMasterSoldOutWithRecommender = masterProduct === null || masterProduct === void 0 ? void 0 : (ref = masterProduct.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.soldoutWithRecommender;
    var productName = (variation === null || variation === void 0 ? void 0 : variation.name) || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBreadcrumb, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                asChild: true,
                gap: {
                    _: "sm",
                    sm: "lg"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-labelledby": "pdp-product-title",
                    className: "mobile:mt-4 tablet:mt-6 desktop:mt-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Grid */.rjZ, {
                            columns: {
                                _: "1",
                                md: "8",
                                lg: "12"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageGallery, {
                                    className: "grid-cols-1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    "aria-label": t("productInfo"),
                                    className: "order-1 h-full md:col-span-4 lg:col-span-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                                        ref: stickyRef,
                                        gap: "base",
                                        className: "md:sticky md:top-[".concat(stickyTop, "px]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                                                asChild: true,
                                                size: {
                                                    _: "base",
                                                    md: "lg",
                                                    xl: "xl"
                                                },
                                                weight: "bold",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                                                    id: "pdp-product-title",
                                                    dataTestId: "pdp-title",
                                                    dangerouslySetInnerHTML: {
                                                        __html: productName
                                                    },
                                                    tag: "h1"
                                                })
                                            }),
                                            isPNARegion && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmplifiStarsBelowPDPTitle, {
                                                sku: (variation === null || variation === void 0 ? void 0 : variation.id) || ""
                                            }),
                                            !isMasterSoldOutWithRecommender && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariantSelectors, {}),
                                            isMasterSoldOutWithRecommender && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SoldOutBanner, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRecommendations, {
                                                        masterProduct: masterProduct,
                                                        recommender: recommender,
                                                        content: content
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (variation === null || variation === void 0 ? void 0 : variation.productStory) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductStory/* ProductStory */.F, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variation.productStory), {
                            additionalContentSections: content === null || content === void 0 ? void 0 : content.ProductStoryAdditionalContentSlot,
                            documentId: content === null || content === void 0 ? void 0 : content._id,
                            slotId: "ProductStoryAdditionalContentSlot"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityContentSlot/* SanityContentSlot */.D, {
                            items: content === null || content === void 0 ? void 0 : content.belowProductStory,
                            slotId: "belowProductStory",
                            documentId: content === null || content === void 0 ? void 0 : content._id
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductDetailsPage.tsx



















var PageContent = function(param) {
    var pageLayout = param.pageLayout, masterProduct = param.masterProduct, variation = param.variation, inventory = param.inventory, content = param.content, productScore = param.productScore, isAppOnly = param.isAppOnly, mixedCartNotAllowed = param.mixedCartNotAllowed, sizeHasChanged = param.sizeHasChanged;
    switch(pageLayout){
        case "simplified":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpSimplifiedLayout, {
                masterProduct: masterProduct,
                variation: variation,
                inventory: inventory,
                content: content,
                mixedCartNotAllowed: mixedCartNotAllowed,
                sizeHasChanged: sizeHasChanged
            });
        case "soldoutWithRecommender":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpSoldoutWithRecommenderLayout, {
                masterProduct: masterProduct,
                variation: variation,
                content: content
            });
        case "noVariant":
            return null;
        case "full":
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpFullLayout, {
                masterProduct: masterProduct,
                variation: variation,
                inventory: inventory,
                content: content,
                productScore: productScore,
                isAppOnly: isAppOnly,
                mixedCartNotAllowed: mixedCartNotAllowed,
                sizeHasChanged: sizeHasChanged
            });
    }
};
var ProductDetailsPage = function() {
    var ref;
    var ref1 = (0,usePdp/* usePdp */.Y)(), desiredSize = ref1.desiredSize, desiredSwatch = ref1.desiredSwatch, masterProduct = ref1.masterProduct, pageLayout = ref1.pageLayout, variation = ref1.variation, content = ref1.content, productScore = ref1.productScore, isAppOnly = ref1.isAppOnly, sizeHasChanged = ref1.sizeHasChanged;
    var cart = (0,useSimpleCart/* useSimpleCart */.r)().cart;
    var selectedSwatch = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.find(function(item) {
        return item.colorValue === desiredSwatch;
    });
    var mixedCartNotAllowed = (cart === null || cart === void 0 ? void 0 : cart.isMixedCartAllowed) === false && sendMixedCartErrorMessage(cart, variation);
    var sizes = selectedSwatch ? (0,products/* getSizesFromSizeGroups */.hJ)(selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.sizeGroups) : [];
    var selectedSize = sizes.find(function(item) {
        return item.id === desiredSize;
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useInventory/* useInventory */.m)(selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId), 1), inventory = ref2[0];
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var ref3 = (0,useGA4Events/* useGA4Events */.tL)(), imageNumber = ref3.imageNumber, imageType = ref3.imageType;
    var ga4Item = (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) && (variation === null || variation === void 0 ? void 0 : variation.colorValue) ? (0,ga4Items/* getGa4Item */.Vr)("".concat(masterProduct.id, "_").concat(variation.colorValue)) : undefined;
    var item = (0,react.useMemo)(function() {
        var product = {
            color: variation === null || variation === void 0 ? void 0 : variation.colorValue,
            id: variation === null || variation === void 0 ? void 0 : variation.id,
            masterId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id,
            masterProduct: masterProduct,
            variantProduct: variation
        };
        return (0,analytics/* transformListProductToAnalyticsItem */.pD)({
            product: product,
            currency: currency.code,
            quantity: 1,
            categories: {
                item_category: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.primaryCategoryId
            },
            itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
            itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
            index: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.idx,
            creativeName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cname,
            creativeSlot: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.cslot,
            promotionId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pid,
            promotionName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.pname,
            itemId: variation === null || variation === void 0 ? void 0 : variation.id,
            itemName: variation === null || variation === void 0 ? void 0 : variation.name
        });
    }, [
        currency.code,
        variation,
        masterProduct,
        ga4Item
    ]);
    useItemViewEvent({
        itemListId: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lid,
        itemListName: ga4Item === null || ga4Item === void 0 ? void 0 : ga4Item.lname,
        itemIdEp: variation === null || variation === void 0 ? void 0 : variation.id,
        itemNameEp: variation === null || variation === void 0 ? void 0 : variation.name,
        value: (variation === null || variation === void 0 ? void 0 : (ref = variation.productPrice) === null || ref === void 0 ? void 0 : ref.salePrice) || undefined,
        imageType: imageType,
        imageNumber: imageNumber,
        item: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            color_code: "a".concat(variation === null || variation === void 0 ? void 0 : variation.colorValue)
        }),
        currency: currency.code,
        desiredSize: desiredSize,
        selectedSize: selectedSize
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(useProductCustomization/* ProductCustomizationProvider */.V, {
        variation: variation,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent, {
            pageLayout: pageLayout,
            masterProduct: masterProduct,
            variation: variation,
            inventory: inventory,
            content: content,
            productScore: productScore,
            isAppOnly: isAppOnly,
            mixedCartNotAllowed: mixedCartNotAllowed,
            sizeHasChanged: sizeHasChanged
        })
    });
};

// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductFitOptions.tsx





var ProductFitOptions = function() {
    var ref;
    var ref1 = (0,usePdp/* usePdp */.Y)(), desiredSwatch = ref1.desiredSwatch, masterProduct = ref1.masterProduct;
    var selectedSwatch = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.find(function(item) {
        return item.colorValue === desiredSwatch;
    });
    var hasAlternativeOrderableFitOptions = masterProduct === null || masterProduct === void 0 ? void 0 : (ref = masterProduct.fitOptions) === null || ref === void 0 ? void 0 : ref.some(function(fitOption) {
        var isDifferentMasterProduct = fitOption.masterProduct.id !== masterProduct.id;
        return isDifferentMasterProduct && fitOption.masterProduct.variations.some(function(variation) {
            return variation.orderable && variation.colorValue === (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.colorValue);
        });
    });
    if (!(masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.fitOptions) || masterProduct.fitOptions.length < 2 || !hasAlternativeOrderableFitOptions) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-4",
        "data-test-id": "fit-options-picker",
        "aria-labelledby": "fit-options-title",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row flex-wrap gap-1",
            children: masterProduct.fitOptions.map(function(fitOption) {
                var productUrl = (0,buildProductUrl/* buildProductUrl */.B)(fitOption.masterProduct.id, fitOption.masterProduct.name, {
                    color: (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.colorValue) || false
                });
                var isCurrentFit = masterProduct.id === fitOption.masterProduct.id;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    disabled: isCurrentFit,
                    dataTestId: "fit-option-".concat(fitOption.masterProduct.id),
                    className: (0,twind.tw)("relative border flex-none opacity-100 rounded-sm px-4 h-8 flex items-center justify-center", isCurrentFit && "bg-puma-black border-puma-black text-white"),
                    variant: "black",
                    href: productUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold text-sm uppercase",
                        children: fitOption.label
                    })
                }, fitOption.masterProduct.id);
            })
        })
    });
};

// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ./ui/components/Img.tsx
var Img = __webpack_require__(53579);
// EXTERNAL MODULE: ./ui/components/CarouselModal.tsx
var CarouselModal = __webpack_require__(39220);
// EXTERNAL MODULE: ./ui/components/Video.tsx + 2 modules
var Video = __webpack_require__(79817);
// EXTERNAL MODULE: ./ui/components/ResponsiveProductImage.tsx
var ResponsiveProductImage = __webpack_require__(99531);
;// CONCATENATED MODULE: ./ui/components/StyliticsWidget/CompleteTheLookBadge.tsx






var CompleteTheLookBadge = function() {
    var translate = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,twind.tw)("absolute right-3 md:right-5 top-3 xl:top-5 z-10"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: "#complete-the-look-carousel",
            className: (0,twind.tw)("invisible", "group transition-all", "relative overflow-hidden rounded-full focus:rounded-full", "outline-none ring-puma-gold focus:bg-puma-gold hover:bg-puma-gold", "bg-puma-black text-puma-black-900", "leading-tight uppercase font-bold text-xs", "flex flex-col items-center justify-center text-center", "h-20 w-20 px-2", "w-20 md:w-16 lg:w-20 h-20 md:h-16 lg:h-20"),
            id: "complete-the-look",
            onClick: function(e) {
                e.preventDefault();
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PDP_INTERACTION */._q.PDP_INTERACTION, {
                    domevent: "Stylitics - Complete the Look",
                    domlabel: ""
                });
                (0,scroll_to/* scrollTo */.X)("complete-the-look-carousel", -80);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "transform -translate-y-1 text-[12px] lg:text-xs whitespace-normal",
                    children: translate("completeTheLook")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": true,
                    className: "transition-all absolute left-1/2 -bottom-2 lg:bottom-0 transform -translate-x-1/2 -translate-y-3 group-hover:-translate-y-2 group-focus:-translate-y-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                        name: "chevron-down",
                        size: "lg"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./ui/components/ProductBadge.tsx + 1 modules
var ProductBadge = __webpack_require__(10395);
// EXTERNAL MODULE: ./utils/debounce.ts
var debounce = __webpack_require__(40572);
// EXTERNAL MODULE: ./ui/pages/ProductDetailsPages/ProductVideoMuteButton.tsx
var ProductVideoMuteButton = __webpack_require__(5972);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductImageGallery.tsx























var ProductImageGallery_CarouselModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39220)).then(function(x) {
        return x.CarouselModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39220)
            ];
        }
    },
    ssr: false
});
var ProductImageGallery = function(param) {
    var className = param.className;
    var ref, ref1;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref2 = (0,useSiteConfig/* useSiteConfig */.N)(), pdpVideosConfig = ref2.pdpVideosConfig, _staticFeatures = ref2.staticFeatures, useVerticalMedia = _staticFeatures.useVerticalMedia, isPNARegion = _staticFeatures.isPNARegion;
    var ref3 = (0,usePdp/* usePdp */.Y)(), pixleeImgs = ref3.pixleeImgs, masterProduct = ref3.masterProduct, isFullLayout = ref3.isFullLayout, isSimplifiedLayout = ref3.isSimplifiedLayout, variation = ref3.variation;
    var ref4 = (0,react.useState)(variation === null || variation === void 0 ? void 0 : variation.variantId), variationId = ref4[0], setVariationId = ref4[1];
    var ref5;
    var ref6 = (0,react.useState)((ref5 = (ref = pdpVideosConfig.productVideoOptions) === null || ref === void 0 ? void 0 : ref.muted) !== null && ref5 !== void 0 ? ref5 : true), isVideoMuted = ref6[0], setIsVideoMuted = ref6[1];
    var ref7 = (0,react.useState)({
        show: false,
        picIndex: 0,
        muted: isVideoMuted
    }), modalState = ref7[0], setModalState = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,graphql/* usePixleeConfigQuery */.QW$)(), 1), pixleeConfigResponse = ref8[0];
    var ref9 = (0,useGA4Events/* useGA4Events */.tL)(), fireClickProductImage = ref9.fireClickProductImage, fireEventGA4ForImageOpened = ref9.fireEventGA4ForImageOpened;
    var pixleeConfig = (ref1 = pixleeConfigResponse.data) === null || ref1 === void 0 ? void 0 : ref1.pixleeConfig;
    var sliderRef = (0,react.useRef)(null);
    var renderMedia = (0,react.useCallback)(function(media, picIndex) {
        var isFirstImage = picIndex === 0;
        var dataTestId = isFirstImage ? "pdp-main-image" : "img-".concat(picIndex, "-").concat(media.__typename);
        if ((0,CarouselModal.isVideo)(media) && pdpVideosConfig.enabled) {
            var video = media;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex-none w-full",
                "data-test-id": dataTestId,
                onClick: function() {
                    return setModalState({
                        show: true,
                        picIndex: picIndex,
                        muted: isVideoMuted
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideoMuteButton/* ProductVideoMuteButton */.$, {
                        isMuted: isVideoMuted,
                        setIsMuted: setIsVideoMuted,
                        className: (0,style.tw)("bg-white text-black rounded-full border-transparent absolute bottom-2 right-2 z-10 m-0 p-2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* Video */.n, {
                        src: video.src,
                        videoOptions: video.videoOptions,
                        muted: isVideoMuted,
                        priority: true
                    })
                ]
            }, video.src);
        } else {
            var image = media;
            var src = useVerticalMedia ? image.verticalImageHref || image.href : image.href;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex-none w-full aspect-1-1 bg-puma-black-800",
                children: [
                    isFirstImage && isPNARegion && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteTheLookBadge, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveProductImage/* ResponsiveProductImage */.U, {
                        src: src,
                        widths: [
                            600,
                            750,
                            900,
                            1050,
                            1200,
                            1350,
                            1500,
                            1750,
                            2000
                        ],
                        sizes: {
                            mobile: "100vw",
                            tablet: isFirstImage ? "50vw" : "25vw",
                            desktop: "33.3vw"
                        },
                        isVertical: useVerticalMedia,
                        alt: image.alt,
                        "data-test-id": dataTestId,
                        loading: isFirstImage ? "eager" : "lazy",
                        onClick: function() {
                            setModalState({
                                show: true,
                                picIndex: picIndex
                            });
                            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PDP_INTERACTION */._q.PDP_INTERACTION, (0,_object_spread/* default */.Z)({
                                interactionType: "Gallery Open"
                            }, (0,analytics/* transformImageUrlToImageInteractionAnalyticsEvent */.bA)(src)));
                            fireClickProductImage(src);
                            fireEventGA4ForImageOpened({
                                itemListId: variation === null || variation === void 0 ? void 0 : variation.id,
                                itemListName: variation === null || variation === void 0 ? void 0 : variation.name
                            });
                        }
                    })
                ]
            }, src);
        }
    }, [
        pdpVideosConfig.enabled,
        isVideoMuted,
        useVerticalMedia,
        isPNARegion,
        fireClickProductImage,
        fireEventGA4ForImageOpened,
        variation === null || variation === void 0 ? void 0 : variation.id,
        variation === null || variation === void 0 ? void 0 : variation.name, 
    ]);
    var videoOptions = pdpVideosConfig.productVideoOptions;
    var galleryItems = [];
    var showGalleryModal = modalState.show && variation && galleryItems;
    if (variation === null || variation === void 0 ? void 0 : variation.images) {
        var _galleryItems;
        (_galleryItems = galleryItems).push.apply(_galleryItems, (0,_to_consumable_array/* default */.Z)(variation === null || variation === void 0 ? void 0 : variation.images.map(function(i) {
            return (0,_object_spread/* default */.Z)({
                __typename: "ProductImage"
            }, i);
        })));
    }
    var videosKey = useVerticalMedia ? "verticalProductVideos" : "productVideos";
    var masterProductVideos = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct[videosKey];
    if (masterProductVideos && pdpVideosConfig.enabled) {
        var _galleryItems1;
        var videos = masterProductVideos.map(function(src) {
            return {
                __typename: "ProductVideo",
                src: src,
                videoOptions: videoOptions
            };
        });
        (_galleryItems1 = galleryItems).splice.apply(_galleryItems1, [
            pdpVideosConfig.videoPosition ? pdpVideosConfig.videoPosition : 0,
            0
        ].concat((0,_to_consumable_array/* default */.Z)(videos)));
    }
    (0,react.useEffect)(function() {
        if (showGalleryModal) setIsVideoMuted(true);
    }, [
        showGalleryModal
    ]);
    (0,react.useEffect)(function() {
        if (variationId !== (variation === null || variation === void 0 ? void 0 : variation.variantId) && sliderRef.current) {
            setVariationId(variation === null || variation === void 0 ? void 0 : variation.variantId);
            sliderRef.current.scrollLeft = 0;
        }
    }, [
        variation === null || variation === void 0 ? void 0 : variation.variantId
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var baseImageContainerClasses = (0,style.tw)({
        "": "relative flex whitespace-nowrap overflow-x-scroll scroll-snap",
        "md:": "grid gap-4 grid-cols-2 overflow-x-auto children:first-child:col-span-full",
        "lg:": "children:first-child:col-span-1 grid-cols-2"
    });
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var analyticsImage = (0,analytics/* transformImageUrlToImageInteractionAnalyticsEvent */.bA)((variation === null || variation === void 0 ? void 0 : variation.preview) || "");
    var triggerEvent = function() {
        if (pageviewEventHasFired) (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
            event_name: analytics/* AnalyticsEvents.IMAGE_VIEWED */._q.IMAGE_VIEWED,
            event_params: {
                item_id_ep: variation === null || variation === void 0 ? void 0 : variation.id,
                item_name_ep: variation === null || variation === void 0 ? void 0 : variation.name,
                color_code_ep: (0,analytics/* addPrefixToAnalyticProp */.lL)(variation === null || variation === void 0 ? void 0 : variation.colorValue),
                style_number_ep: variation === null || variation === void 0 ? void 0 : variation.styleNumber,
                image_type: analyticsImage.imageType
            }
        });
    };
    (0,react.useEffect)(function() {
        var handleScroll = (0,debounce/* debounce */.D)(function() {
            triggerEvent();
        }, 100);
        var scrollEventListenerRef = sliderRef.current;
        if (scrollEventListenerRef) {
            scrollEventListenerRef.addEventListener("scroll", handleScroll);
        }
        return function() {
            if (scrollEventListenerRef) {
                scrollEventListenerRef.removeEventListener("scroll", handleScroll);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                "data-test-id": "product-image-gallery-section",
                className: "order-1 relative md:col-span-4 lg:col-span-8",
                "aria-label": translate("productGallery"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* SaleBadge */.fD, {
                        variant: variation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: sliderRef,
                        className: (0,style.tw)([
                            (0,style/* apply */.nn)(baseImageContainerClasses),
                            className
                        ]),
                        children: [
                            galleryItems.slice(0, isSimplifiedLayout ? 1 : galleryItems.length).map(renderMedia),
                            isFullLayout && (pixleeImgs === null || pixleeImgs === void 0 ? void 0 : pixleeImgs.map(function(img, index) {
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative w-full flex-none",
                                    children: [
                                        img.source && (pixleeConfig === null || pixleeConfig === void 0 ? void 0 : pixleeConfig.socialMediaIcon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                            name: "social-" + img.source,
                                            size: "3xl",
                                            className: "absolute top-3 left-3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                                            src: img.href,
                                            alt: img.alt,
                                            width: 400,
                                            onClick: function() {
                                                return setModalState({
                                                    show: true,
                                                    picIndex: galleryItems.length + index
                                                });
                                            }
                                        })
                                    ]
                                }, img.href);
                            }))
                        ]
                    })
                ]
            }),
            showGalleryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageGallery_CarouselModal, {
                galleryItems: galleryItems,
                modalState: modalState,
                pixleeImages: pixleeImgs,
                isSocialIconVisible: !!(pixleeConfig === null || pixleeConfig === void 0 ? void 0 : pixleeConfig.socialMediaIcon),
                onClose: function() {
                    setModalState({
                        show: false,
                        picIndex: 0,
                        muted: true
                    });
                },
                triggerEvent: triggerEvent
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/components/AfterpayOrKlarnaText.tsx + 1 modules
var AfterpayOrKlarnaText = __webpack_require__(72026);
// EXTERNAL MODULE: ./ui/components/StarRating.tsx
var StarRating = __webpack_require__(98567);
// EXTERNAL MODULE: ./ui/components/ProductPrice/ProductPrice.tsx + 3 modules
var ProductPrice = __webpack_require__(1108);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductInfo.tsx













var ProductInfo = function(props) {
    var ref, ref1, ref2, ref3;
    var showDynamicTaxMessage = (0,useFeature/* useFeature */.S)("SHOW_DYNAMIC_TAX_MESSAGE");
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref4 = (0,useSiteConfig/* useSiteConfig */.N)(), _staticFeatures = ref4.staticFeatures, showHeaderSubHeaderProductDetail = _staticFeatures.showHeaderSubHeaderProductDetail, isPNARegion = _staticFeatures.isPNARegion;
    var ref5 = (0,usePdp/* usePdp */.Y)(), masterProduct = ref5.masterProduct, variation = ref5.variation;
    var price = variation === null || variation === void 0 ? void 0 : (ref = variation.productPrice) === null || ref === void 0 ? void 0 : ref.price;
    var salePrice = variation === null || variation === void 0 ? void 0 : (ref1 = variation.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice;
    var promotionPrice = variation === null || variation === void 0 ? void 0 : (ref2 = variation.productPrice) === null || ref2 === void 0 ? void 0 : ref2.promotionPrice;
    var isSalePriceElapsed = variation === null || variation === void 0 ? void 0 : (ref3 = variation.productPrice) === null || ref3 === void 0 ? void 0 : ref3.isSalePriceElapsed;
    var productName = showHeaderSubHeaderProductDetail ? masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.header : variation === null || variation === void 0 ? void 0 : variation.name;
    var shouldShowEmplifiStars = isPNARegion && !(masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.disableRatings);
    var shouldShowDefaultStars = !isPNARegion && Number(props.reviewCount) >= 3;
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        gap: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                asChild: true,
                size: {
                    _: "base",
                    md: "lg",
                    xl: "xl"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-1",
                    "data-test-id": "pdp-product-info-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagedHeading/* ManagedHeading */.P, {
                            tag: "h1",
                            mainHeading: true,
                            id: "pdp-product-title",
                            dataTestId: "pdp-title",
                            dangerouslySetInnerHTML: {
                                __html: productName
                            }
                        }),
                        showHeaderSubHeaderProductDetail && (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.subHeader) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            "data-test-id": "pdp-product-subheader",
                            className: "w-full mobile:text-md font-normal text-lg text-puma-gray-60 line-clamp-2",
                            children: masterProduct.subHeader
                        })
                    ]
                })
            }),
            shouldShowEmplifiStars && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmplifiStarsBelowPDPTitle, {
                sku: (ref6 = variation === null || variation === void 0 ? void 0 : variation.id) !== null && ref6 !== void 0 ? ref6 : ""
            }),
            shouldShowDefaultStars && /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                dataTestId: "rating-under-title",
                rating: props.rating,
                pageAnchorId: "product-reviews"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* ProductBadges */.aS, {
                variant: variation
            }),
            variation && variation.price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* LiveRegion */.LE2, {
                type: "polite",
                atomic: true,
                "data-test-id": "pdp-price-region",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    className: "h-auto",
                    "data-test-id": "pdp-price",
                    items: {
                        _: "center",
                        lg: "start"
                    },
                    direction: {
                        _: "row",
                        lg: "column"
                    },
                    gap: {
                        _: "sm",
                        lg: "xxs"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                            direction: "row",
                            items: "center",
                            className: "w-auto",
                            gap: {
                                _: "sm",
                                lg: "xs"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.jF, (0,_object_spread/* default */.Z)({
                                price: {
                                    amount: price,
                                    salePrice: salePrice,
                                    promotionPrice: promotionPrice,
                                    isSalePriceElapsed: isSalePriceElapsed
                                },
                                compact: true
                            }, ProductPrice/* PDP_PRICE_STRATEGY */.iB))
                        }),
                        translate("priceClarification") && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                            "data-test-id": "tax-clarification-text",
                            size: "sm",
                            color: "muted",
                            children: showDynamicTaxMessage ? variation.taxDisplayMsg : translate("priceClarification")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AfterpayOrKlarnaText/* AfterpayOrKlarnaText */.y, {
                            amount: salePrice || price
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/components/ProductPromotions.tsx
var ProductPromotions = __webpack_require__(7681);
// EXTERNAL MODULE: ./utils/dateCalculations.ts
var dateCalculations = __webpack_require__(35525);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductMessages.tsx










var ProductMessages = function() {
    var useVariantPromotionExclusion = (0,useFeature/* useFeature */.S)("USE_VARIANT_PROMOTION_EXCLUSION");
    var showPromoExclusionMsgInGray = (0,useFeature/* useFeature */.S)("SHOW_PROMO_EXCLUSION_MSG_IN_GRAY");
    var ref = (0,usePdp/* usePdp */.Y)(), masterProduct = ref.masterProduct, variation = ref.variation, isAppOnly = ref.isAppOnly;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (useVariantPromotionExclusion && (variation === null || variation === void 0 ? void 0 : variation.promotionExclusion) || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.promotionExclusion)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,twind.tw)(showPromoExclusionMsgInGray && "text-puma-gray"),
                children: t("promotionExclusion")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPromotions/* ProductPromotions */._, {
                variant: variation
            }),
            (variation === null || variation === void 0 ? void 0 : variation.specialMessage) && (!isAppOnly || (0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppOnly, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeFrom, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeTo)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMessage, {
                variant: variation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockMessage, {
                variant: variation
            })
        ]
    });
};
var SpecialMessage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeHtml/* SafeHtml */.T, {
        as: "span",
        "data-test-id": "product-special-message-text",
        html: props.variant.specialMessage,
        className: "border-b pb-6"
    });
};
var OutOfStockMessage = function(props) {
    var ref;
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), locale = ref1.locale, showTimeZoneName = ref1.staticFeatures.showTimeZoneName;
    var t = (0,useTranslations/* useTranslate */.qM)();
    // Do not show the availability date if there is no `displayOutOfStock`,
    // or if `comingsoon` is false, or there is no `validTo` date provided
    var displayOutOfStock = (ref = props.variant) === null || ref === void 0 ? void 0 : ref.displayOutOfStock;
    if (!displayOutOfStock || !displayOutOfStock.comingsoon || !displayOutOfStock.validTo) return null;
    var formattedDate = (0,dateCalculations/* timezoneDateFormat */.ci)(displayOutOfStock.validTo, locale, showTimeZoneName);
    // For JP change 12AM for 0AM
    var adjustedFormattedDate = formattedDate.replace("午前12時", "午前0時");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-lg font-bold border-b pb-6",
        "data-test-id": "product-availability-message-text",
        children: t("availableToOrderOn", {
            date: adjustedFormattedDate
        })
    });
};

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./utils/personalise.ts
var parseLocaleForFluidConfigure = function(lang, country) {
    // For India Fluid Configure does not accept en_IN as locale, instead en_GB are accepted.
    var locale = "".concat(lang, "_").concat(country.toLocaleUpperCase());
    var parsedLocale = locale === "en_IN" ? "en_GB" : locale;
    return {
        locale: parsedLocale
    };
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductPersonalise.tsx













var ProductPersonalise = function() {
    var ref = (0,react.useState)(false), initPersonalizationReady = ref[0], setInitPersonalizationReady = ref[1];
    var ref1 = (0,react.useState)(false), showSizeGuide = ref1[0], setShowSizeGuide = ref1[1];
    var ref2 = (0,usePdp/* usePdp */.Y)(), masterProduct = ref2.masterProduct, variation = ref2.variation, setAddToCartError = ref2.setAddToCartError;
    var addToCart = (0,useCart/* useCart */.j)({
        pause: true
    }).addToCart;
    var openMiniCart = (0,useMiniCart/* useMiniCart */.lm)().openMiniCart;
    var ref3 = (0,useSiteConfig/* useSiteConfig */.N)(), _currency = ref3.currency, currencyCode = _currency.code, _env = ref3.env, configureIdScriptUrl = _env.configureIdScriptUrl, configureIdApiKey = _env.configureIdApiKey, language = ref3.language, countryCode = ref3.countryCode;
    (0,react.useEffect)(function() {
        var ref;
        var locale = parseLocaleForFluidConfigure(language, countryCode).locale;
        //Init
        window.configureParams = {
            productId: masterProduct === null || masterProduct === void 0 ? void 0 : (ref = masterProduct.configureID) === null || ref === void 0 ? void 0 : ref.productID,
            demandwareProductID: variation === null || variation === void 0 ? void 0 : variation.variantId,
            demandwareConfigureAPIKey: configureIdApiKey,
            currency: currencyCode,
            locale: locale
        };
        window.openSizeChart = function() {
            setShowSizeGuide(true);
        };
        setInitPersonalizationReady(true);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        // Callback when a Fluid Configure product is added to cart
        window.addToCart = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(recipe) {
                var ref, ref1, sizes, selectedSize, ref2, res, _tmp, items;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sizes = variation ? (0,products/* getSizesFromSizeGroups */.hJ)(variation.sizeGroups) : [];
                            selectedSize = sizes.find(function(x) {
                                return x.productId === recipe.data.productItemNumber;
                            });
                            _tmp = {};
                            return [
                                4,
                                addToCart((_tmp.swatch = variation.colorValue, _tmp.size = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.id, _tmp.quantity = Number(recipe.product_quantities.product), _tmp.productId = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId, _tmp.productPersonalization = (ref2 = {
                                    imageURL: "".concat(recipe.images.view_1.split(",")[0], ",0.60.png"),
                                    largeImageURL: recipe.images.view_1,
                                    nameText: recipe.data.nameText,
                                    numberText: recipe.data.numberText,
                                    price: String(recipe.prices[currencyCode]),
                                    recipeID: String(recipe.product.id),
                                    quantity: recipe.custom.quantity
                                }) !== null && ref2 !== void 0 ? ref2 : undefined, _tmp.masterId = variation.masterId, _tmp))
                            ];
                        case 1:
                            res = _state.sent();
                            if ((0,extractError/* extractError */.d)(res)) {
                                setAddToCartError((0,extractError/* extractError */.d)(res));
                                return [
                                    2
                                ];
                            }
                            items = (ref1 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.addItemsToCart.products) === null || ref1 === void 0 ? void 0 : ref1.filter(function(product) {
                                return product.__typename === "ProductCartItem" && (product === null || product === void 0 ? void 0 : product.product.id) === (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId);
                            });
                            if (items) openMiniCart(items);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(recipe) {
                return _ref.apply(this, arguments);
            };
        }();
    // we should re-initialize the method so as to have cartId in the context when it's changed
    }, [
        addToCart,
        currencyCode,
        openMiniCart,
        setAddToCartError,
        variation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "fluidConfigure",
        children: [
            initPersonalizationReady && configureIdScriptUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    async: true,
                    src: configureIdScriptUrl
                })
            }),
            showSizeGuide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes/* SizeGuide */.$7, {
                categoryId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.primaryCategoryId,
                productMeasurements: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productMeasurements,
                onClickOutside: function() {
                    return setShowSizeGuide(false);
                },
                productDivision: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productDivision
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/content/CallToActions.tsx + 1 modules
var CallToActions = __webpack_require__(85814);
// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(93451);
// EXTERNAL MODULE: ./ui/elements/Accordion.tsx
var Accordion = __webpack_require__(36998);
// EXTERNAL MODULE: ./ui/content/SignUpFormField.tsx
var SignUpFormField = __webpack_require__(32042);
;// CONCATENATED MODULE: ./ui/content/SignUpFormPdpComingSoon.tsx
















var SignUpFormPdpComingSoon = function(param) {
    var signUpForm = param.signUpForm, variation = param.variation;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateContactMutation */.LrK)(), 2), createContactResult = ref1[0], createContact = ref1[1];
    var countryCode = (0,useSiteConfig/* useSiteConfig */.N)().countryCode;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useInView/* useInView */.Y)(), 2), signUpFormPdpComingSoonInViewRef = ref2[0], signUpFormPdpComingSoonInView = ref2[1];
    (0,react.useEffect)(function() {
        if (signUpFormPdpComingSoonInView) {
            (0,analytics/* emailSignUpEvent */.QZ)(analyticTypes/* EmailSignUpActions.Impression */.VF.Impression, "SignUpFormPDPComingSoon");
        }
    }, [
        signUpFormPdpComingSoonInView
    ]);
    var submittedSuccessfully = createContactResult.data && !createContactResult.error && !createContactResult.fetching;
    var header = (0,react.useMemo)(function() {
        if (submittedSuccessfully) return (signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm.successHeader) || "";
        return (signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm.header) || "";
    }, [
        signUpForm,
        submittedSuccessfully
    ]);
    var copy = (0,react.useMemo)(function() {
        if (submittedSuccessfully) return (signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm.successCopy) || "";
        return (signUpForm === null || signUpForm === void 0 ? void 0 : signUpForm.copy) || "";
    }, [
        signUpForm,
        submittedSuccessfully
    ]);
    var form = (0,index_esm/* useForm */.cI)({
        defaultValues: {},
        shouldUnregister: false,
        mode: "onSubmit"
    });
    var submitForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data, contactSource) {
            var contact, result, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        contact = (0,SignUpFormField/* createContactInput */.h)(data, contactSource, countryCode);
                        _tmp = {};
                        return [
                            4,
                            createContact((_tmp.input = {
                                contact: contact
                            }, _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        (0,analytics/* emailSignUpEvent */.QZ)(result.error ? analyticTypes/* EmailSignUpActions.Error */.VF.Error : analyticTypes/* EmailSignUpActions.Submit */.VF.Submit, "SignUpFormPDPComingSoon");
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function submitForm(data, contactSource) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (form.formState.isSubmitted && Object.keys(form.formState.errors).length) {
            (0,analytics/* emailSignUpEvent */.QZ)(analyticTypes/* EmailSignUpActions.Error */.VF.Error, "SignUpFormPDPComingSoon");
        }
    }, [
        form.formState
    ]);
    if (!signUpForm || !(variation === null || variation === void 0 ? void 0 : (ref = variation.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.comingsoon)) return null;
    var details = {
        ctaLabel: signUpForm.submitButtonText
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* AccordionRoot */.c2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* AccordionTab */.US, {
            bodyClassNameConfig: {
                baseClassName: "pt-2 pb-8"
            },
            dataTestId: "sign-up-form-pdp-coming-soon-accordion",
            expand: true,
            headerClassNameConfig: {
                baseClassName: "font-bold text-xl h-auto"
            },
            id: "sign-up-form-pdp-coming-soon-accordion",
            title: header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base mb-8",
                    children: copy
                }),
                !submittedSuccessfully && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "flex w-full flex-col",
                    onSubmit: form.handleSubmit(function(data) {
                        return submitForm(data, signUpForm.contactSource);
                    }),
                    children: [
                        (0,extractError/* extractError */.d)(createContactResult) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Alert */.bZj, {
                                content: (0,extractError/* extractError */.d)(createContactResult),
                                dataTestId: "sign-up-form-pdp-coming-soon-error",
                                title: "Error",
                                variant: "error"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid gap-4 mb-8",
                                    ref: signUpFormPdpComingSoonInViewRef,
                                    children: signUpForm.fields.map(function(field) {
                                        switch(field){
                                            case "address":
                                                {
                                                    return [
                                                        "address",
                                                        "city",
                                                        "zip-code"
                                                    ].map(function(name) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-full",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                                form: form,
                                                                field: name,
                                                                isLoading: createContactResult.fetching,
                                                                details: details
                                                            })
                                                        }, name);
                                                    });
                                                }
                                            case "name":
                                                {
                                                    return [
                                                        "firstName",
                                                        "lastName"
                                                    ].map(function(name) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-full",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                                form: form,
                                                                field: name,
                                                                isLoading: createContactResult.fetching,
                                                                details: details
                                                            })
                                                        }, name);
                                                    });
                                                }
                                            case "ticketChoice":
                                                {
                                                    return null;
                                                }
                                            default:
                                                {
                                                    var fullRow = [
                                                        "ageCheck",
                                                        "emailPreference",
                                                        "opt-out", 
                                                    ].includes(field);
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,css.tw)(fullRow && "flex justify-start mt-4 col-span-full"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormField/* SignUpFormField */.B, {
                                                            form: form,
                                                            field: field,
                                                            isLoading: createContactResult.fetching,
                                                            details: details
                                                        })
                                                    }, field);
                                                }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                    className: "w-full",
                                    dataTestId: "sign-up-form-pdp-coming-soon-submit-button",
                                    label: signUpForm.submitButtonText,
                                    size: "lg",
                                    type: "submit"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/Sizes/StockMessage.tsx



var STOCK_THRESHOLDS = {
    veryLow: 5,
    low: 10
};
var StockMessageText = function(param) {
    var quantity = param.quantity;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var text = t("inStock");
    if (quantity === 0) {
        text = t("outOfStock");
    } else if (quantity <= STOCK_THRESHOLDS.veryLow) {
        text = t("lowStockQuantity", {
            quantity: quantity
        });
    } else if (quantity > STOCK_THRESHOLDS.veryLow && quantity <= STOCK_THRESHOLDS.low) {
        text = t("lowStock");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: text
    });
};
var StockMessage = function(param) {
    var className = param.className, quantity = param.quantity, selectedSize = param.selectedSize;
    // Return null:
    //   - If quantity is undefined (it hasn't been retrieved yet) & size is orderable.
    //   - If selectedSize is undefined, no size has been chosen.
    //   - If selectedSize.orderable is undefined, stock status is unknown.
    if (!selectedSize || selectedSize.orderable === undefined) return null;
    if (quantity === undefined && selectedSize.orderable) return null;
    var productQuantity = 0; // default to 0
    if (quantity) productQuantity = quantity;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        "data-test-id": "low-inventory-message",
        className: (0,css.tw)([
            "text-xs uppercase flex font-bold",
            className
        ]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StockMessageText, {
            quantity: productQuantity
        })
    });
};

// EXTERNAL MODULE: ./ui/components/Sizes/StockMessageSFCC.tsx
var StockMessageSFCC = __webpack_require__(12450);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ModelMeasurementCallout.tsx



var ModelMeasurementCallout = function(param) {
    var measurementText = param.measurementText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* CalloutRoot */.PLo, {
        bleed: true,
        fill: true,
        outline: true,
        inset: "sm",
        variant: "muted",
        className: "bg-gray-100 flex items-center",
        "data-test-id": "model-measurement-text",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CalloutIcon */.nuQ, {
                icon: "info"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CalloutBody */.ip, {
                children: measurementText === null || measurementText === void 0 ? void 0 : measurementText.split("\n").map(function(text) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                            children: text
                        })
                    }, text);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductVariantSelectors.tsx


















// Shows Products color picker, product messages (such as coming soon, promos,
// etc), product customizer button, and product size picker.
var ProductVariantSelectors = function(param) {
    var inventory = param.inventory;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref6 = (0,usePdp/* usePdp */.Y)(), desiredSize = ref6.desiredSize, productIsOrderable = ref6.productIsOrderable, masterProduct = ref6.masterProduct, variation = ref6.variation, content = ref6.content, isAppOnly = ref6.isAppOnly;
    var ref7 = (0,useSiteConfig/* useSiteConfig */.N)(), _staticFeatures = ref7.staticFeatures, useStockInfoRedesign = _staticFeatures.useStockInfoRedesign, multipleModelMeasurementEnabled = _staticFeatures.multipleModelMeasurementEnabled;
    var personalizationEnabled = (0,useFeature/* useFeature */.S)("PERSONALIZATION_ENABLED");
    var showStockMessageBySFCCLogic = (0,useFeature/* useFeature */.S)("PDP_SHOW_DETAILED_STOCK_MESSAGES");
    var enableStockMessage = (0,useFeature/* useFeature */.S)("PDP_ENABLE_STOCK_MESSAGE");
    var productName = (variation === null || variation === void 0 ? void 0 : variation.name) || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name) || "";
    var exploreMoreCTA = content === null || content === void 0 ? void 0 : content.ctaAboveSpecialMessage;
    var queryParams = "";
    if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.swatch) {
        queryParams = "?swatch=".concat(router.query.swatch);
    }
    if (masterProduct === null || masterProduct === void 0 ? void 0 : (ref1 = masterProduct.displayOutOfStock) === null || ref1 === void 0 ? void 0 : ref1.soldoutWithRecommender) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SoldOutBanner, {});
    }
    var ref8;
    var sizes = (0,products/* getSizesFromSizeGroups */.hJ)((ref8 = variation === null || variation === void 0 ? void 0 : variation.sizeGroups) !== null && ref8 !== void 0 ? ref8 : []);
    var selectedSize = desiredSize ? sizes === null || sizes === void 0 ? void 0 : sizes.find(function(x) {
        return x.id === desiredSize;
    }) : undefined;
    var showSelectFitLabel = !!((variation === null || variation === void 0 ? void 0 : (ref2 = variation.sizeGroups) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.label) || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.fitOptions));
    // Logic for where to show Stock Message component
    var hasModelText = !!(variation === null || variation === void 0 ? void 0 : variation.modelMeasurementText);
    var showNextToSelectFitLabel = showSelectFitLabel && !hasModelText;
    var showNextToModelText = hasModelText;
    var showAlone = !showSelectFitLabel && !hasModelText;
    var stockMessage = !showStockMessageBySFCCLogic ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StockMessage, {
        className: "absolute right-0 top-4",
        selectedSize: selectedSize,
        quantity: inventory
    }) : null;
    var stockMessageSFFC = enableStockMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StockMessageSFCC/* StockMessageSFCC */.O, {
            selectedSize: selectedSize,
            quantity: inventory
        })
    }) : null;
    var stockMessageOrSFFC = stockMessage !== null && stockMessage !== void 0 ? stockMessage : stockMessageSFFC;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductColorPicker, {}),
            (variation === null || variation === void 0 ? void 0 : variation.modelMeasurementText) && multipleModelMeasurementEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelMeasurementCallout, {
                measurementText: variation.modelMeasurementText
            }),
            exploreMoreCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActions/* CallToActions */.l, {
                ctas: exploreMoreCTA,
                className: "font-bold border border-gray-600 rounded-sm uppercase py-4"
            }),
            productIsOrderable && (variation === null || variation === void 0 ? void 0 : (ref4 = variation.configureID) === null || ref4 === void 0 ? void 0 : ref4.enabled) && personalizationEnabled && masterProduct && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "text-xs font-bold",
                        children: t("personalization")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        as: "button",
                        href: "".concat((0,buildProductUrl/* buildProductUrl */.B)(masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id, productName), "/personalise").concat(queryParams),
                        className: "flex-none flex flex-col relative",
                        children: t("personalise")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Separator */.Z0O, {
                gap: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMessages, {}),
            variation && productIsOrderable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: !(0,isAppExclusiveValidRange/* isAppExclusiveValidRange */.o)(isAppOnly, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeFrom, variation === null || variation === void 0 ? void 0 : variation.appOnlyDateTimeTo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomizer, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            id: "fit-options-title",
                                            className: "font-bold text-xl mb-4",
                                            children: !showSelectFitLabel ? t("sizePdp") : t("selectFit")
                                        }),
                                        showSelectFitLabel && showNextToSelectFitLabel && stockMessage
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-between",
                                    "data-test-id": "model-inventory",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            (variation === null || variation === void 0 ? void 0 : variation.modelMeasurementText) && !multipleModelMeasurementEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs font-bold uppercase mr-2 mb-4".concat(useStockInfoRedesign ? " place-self-center" : ""),
                                                "data-test-id": "model-measurement-text",
                                                children: variation.modelMeasurementText
                                            }),
                                            (showNextToModelText || showAlone) && (useStockInfoRedesign ? stockMessageOrSFFC : stockMessage)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFitOptions, {}),
                                useStockInfoRedesign ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSizePicker, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSizePicker, {
                                    inventory: inventory
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SoldOutBanner, {
                        message: variation === null || variation === void 0 ? void 0 : (ref5 = variation.displayOutOfStock) === null || ref5 === void 0 ? void 0 : ref5.displayValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpFormPdpComingSoon, {
                        signUpForm: content === null || content === void 0 ? void 0 : content.comingSoonSignUpForm,
                        variation: variation
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./hooks/useWishlist.ts + 1 modules
var useWishlist = __webpack_require__(60581);
// EXTERNAL MODULE: ./ui/components/RemoveWishlistItemModal.tsx
var RemoveWishlistItemModal = __webpack_require__(81985);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ProductWishlistButton.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* Hide the text label div */\n    & [data-uds-child='text-label'] {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var ProductWishlistButton = function(param) {
    var disabled = param.disabled, quantity = param.quantity;
    var ref;
    var ref1 = (0,react.useState)(false), addingToWishlist = ref1[0], setAddingToWishlist = ref1[1];
    var ref2 = (0,react.useState)(false), removingFromWishlist = ref2[0], setRemovingFromWishlist = ref2[1];
    var canRemoveWishlistItemsFromPDP = (0,useFeature/* useFeature */.S)("CAN_REMOVE_WISHLIST_ITEMS_FROM_PDP");
    var auth = (0,useAuth/* useAuth */.aC)();
    var router = (0,next_router.useRouter)();
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var ref3 = (0,useSiteConfig/* useSiteConfig */.N)(), localizeUrlPath = ref3.localizeUrlPath, country = ref3.country;
    // DO NOT SHOW miniCart for US & CA
    var showMiniCart = country !== constants/* SUPPORTED_COUNTRY.CA */.bM.CA && country !== constants/* SUPPORTED_COUNTRY.US */.bM.US;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useWishlist/* useWishlist */.E)(false, showMiniCart), 2), wishlist = ref4[0], ref5 = ref4[1], addToWishlist = ref5.add, removeFromWishList = ref5.remove;
    var openMiniCart = (0,useMiniCart/* useMiniCart */.lm)().openMiniCart;
    var ref6 = (0,usePdp/* usePdp */.Y)(), desiredSize = ref6.desiredSize, desiredSwatch = ref6.desiredSwatch, masterProduct = ref6.masterProduct, productIsOrderable = ref6.productIsOrderable, setAddToCartError = ref6.setAddToCartError;
    var isMatchingItem = (0,react.useCallback)(function(param) {
        var masterId = param.masterId, colorValue = param.colorValue, sizeValue = param.sizeValue;
        return masterId === (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) && colorValue === desiredSwatch && sizeValue === desiredSize;
    }, [
        masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id,
        desiredSize,
        desiredSwatch
    ]);
    var findWishlistItem = (0,react.useCallback)(function() {
        var ref;
        var wishListItems = ((ref = wishlist.data) === null || ref === void 0 ? void 0 : ref.wishList.items) || [];
        return wishListItems.find(function(param) {
            var product = param.product;
            var masterId = product.masterId, colorValue = product.colorValue, size = product.size;
            return isMatchingItem({
                masterId: masterId,
                colorValue: colorValue,
                sizeValue: size.value
            });
        });
    }, [
        isMatchingItem,
        (ref = wishlist.data) === null || ref === void 0 ? void 0 : ref.wishList.items
    ]);
    // True if wishlist item
    var wishlistItem = (0,react.useMemo)(function() {
        var ref;
        var wishListItems = ((ref = wishlist.data) === null || ref === void 0 ? void 0 : ref.wishList.items) || [];
        var isWishListEmpty = !(wishListItems === null || wishListItems === void 0 ? void 0 : wishListItems.length);
        if (isWishListEmpty || !masterProduct) return undefined;
        return findWishlistItem();
    }, [
        wishlist,
        masterProduct,
        findWishlistItem
    ]);
    var wishlistLoading = addingToWishlist || removingFromWishlist;
    var showRemoveWishListModal = removingFromWishlist && (wishlistItem === null || wishlistItem === void 0 ? void 0 : wishlistItem.product);
    (0,react.useEffect)(function() {
        if (router.query.wishlist && router.query.wishlist === "true" && (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) && desiredSize && desiredSwatch && productIsOrderable) {
            if (wishlistItem || addingToWishlist) {
                return;
            }
            setAddingToWishlist(true);
            addToWishlist({
                input: {
                    productId: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id,
                    swatch: desiredSwatch,
                    size: desiredSize,
                    quantity: quantity
                }
            }).then(function(res) {
                var ref;
                var item = (ref = res.data) === null || ref === void 0 ? void 0 : ref.addItemToWishList.items.find(function(wishListItem) {
                    isMatchingItem({
                        masterId: wishListItem.product.masterId,
                        colorValue: wishListItem.product.colorValue,
                        sizeValue: wishListItem.product.size.value
                    });
                });
                if (item && showMiniCart) openMiniCart(item);
            }).catch(function() {
                return undefined;
            }).finally(function() {
                var _query = router.query, wishlist = _query.wishlist, query = (0,_object_without_properties/* default */.Z)(_query, [
                    "wishlist"
                ]);
                setAddingToWishlist(false);
                router.replace({
                    query: query
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        desiredSize,
        desiredSwatch,
        masterProduct,
        productIsOrderable,
        router.query,
        isMatchingItem, 
    ]);
    var addItemToWishlist = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setAddingToWishlist(true);
                    _tmp = {};
                    return [
                        4,
                        addToWishlist((_tmp.input = {
                            productId: masterProduct.id,
                            swatch: desiredSwatch,
                            size: desiredSize,
                            quantity: quantity
                        }, _tmp)).then(function(res) {
                            var ref;
                            // Only for US & CA
                            if (!showMiniCart) window.dispatchEvent(new Event("PRODUCT_WISHLIST_BUTTON_CLICKED"));
                            var item = (ref = res.data) === null || ref === void 0 ? void 0 : ref.addItemToWishList.items.find(function(wishListItem) {
                                isMatchingItem({
                                    masterId: wishListItem.product.masterId,
                                    colorValue: wishListItem.product.colorValue,
                                    sizeValue: wishListItem.product.size.value
                                });
                            });
                            if (item && showMiniCart) openMiniCart(item);
                        })
                    ];
                case 1:
                    _state.sent();
                    setAddingToWishlist(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        desiredSize,
        desiredSwatch,
        masterProduct,
        addToWishlist
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var handleWishlistOnClick = (0,react.useCallback)(function() {
        if (!masterProduct) return;
        if (!desiredSize) {
            setAddToCartError(translate("pleaseSelectSize"));
            return;
        }
        // If guest, reroute to login page
        if (auth.guest) {
            router.push(localizeUrlPath("account/login?from=pd/".concat(router.query.model, "/").concat(router.query.id, "&swatch=").concat(router.query.swatch, "&size=").concat(router.query.size, "&wishlist=true")));
            return;
        }
        // If canRemoveWishlistItemsFromPDP, item can be added/removed from wishlist
        // Otherwise only add item.
        if (canRemoveWishlistItemsFromPDP) {
            if (!wishlistItem) {
                addItemToWishlist();
            } else {
                setRemovingFromWishlist(true); // triggers remove modal to show
            }
        } else if (wishlistItem && !showMiniCart) {
            removeWishlistItem();
        } else addItemToWishlist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        addItemToWishlist,
        auth.guest,
        canRemoveWishlistItemsFromPDP,
        desiredSize,
        localizeUrlPath,
        masterProduct,
        router.query,
        setAddToCartError,
        setRemovingFromWishlist,
        translate,
        wishlistItem, 
    ]);
    var removeWishlistItem = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!wishlistItem) return [
                        3,
                        2
                    ];
                    setRemovingFromWishlist(true);
                    _tmp = {};
                    return [
                        4,
                        removeFromWishList((_tmp.input = {
                            itemId: wishlistItem.id
                        }, _tmp))
                    ];
                case 1:
                    _state.sent();
                    setRemovingFromWishlist(false);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        wishlistItem,
        removeFromWishList,
        setRemovingFromWishlist
    ]);
    var wishlistButtonLabel = (0,react.useMemo)(function() {
        return canRemoveWishlistItemsFromPDP ? translate(wishlistItem ? "removeFromWishlist" : "addToWishlist") : !showMiniCart && wishlistItem ? translate("miniWishListAddedToWishlist") : translate("addToWishlist");
    }, [
        wishlistItem,
        translate,
        canRemoveWishlistItemsFromPDP,
        showMiniCart
    ]);
    var switchHeartIcon = wishlistItem ? "heart-filled" : "heart";
    // Custom styles for the button cta using Twind's css template literal
    var wishListIconStyling = (0,css/* css */.iv)(_templateObject());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ButtonCta */.NlM, {
                id: "add-to-wishlist",
                dataTestId: "add-to-wishlist",
                disabled: disabled || wishlistLoading,
                srOnlyLabel: wishlistButtonLabel,
                loading: auth.guest ? false : wishlistLoading,
                icon: switchHeartIcon,
                size: "lg",
                variant: "secondary",
                onClick: handleWishlistOnClick,
                mode: "text",
                round: false,
                className: (0,css.tw)(wishListIconStyling)
            }),
            showRemoveWishListModal && (wishlistItem === null || wishlistItem === void 0 ? void 0 : wishlistItem.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveWishlistItemModal/* RemoveWishlistItemModal */.v, {
                onClickOutside: function() {
                    return setRemovingFromWishlist(false);
                },
                onConfirm: removeWishlistItem,
                product: wishlistItem.product
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/serializeBlockContent.tsx
var serializeBlockContent = __webpack_require__(88313);
;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ShippingReturnsDetails.tsx





var ShippingReturnsDetails = function(props) {
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var callout = props.callout;
    var freeShippingThreshold = props.freeShippingThreshold;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        gap: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                asChild: true,
                size: "sm",
                weight: "bold",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: translate("shippingAndReturns")
                })
            }),
            callout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(serializeBlockContent/* Prose */.Mr, {
                content: callout
            }) : freeShippingThreshold ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Text */.xvT, {
                size: "base",
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: translate("freeStandardShipping", {
                        days: 30,
                        threshold: freeShippingThreshold,
                        currency: currency.symbol
                    }, {
                        supportHTMLTags: true
                    })
                })
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./utils/scheduledFreeShipping.ts


var getScheduledFreeShippingThreshold = function(scheduledFreeShipping) {
    var ref = scheduledFreeShipping || {}, scheduledThresholds = ref.scheduledThresholds, dateToCheck = ref.dateToCheck;
    if (!scheduledThresholds || !dateToCheck) {
        return null;
    }
    var activeScheduledThreshold = scheduledThresholds === null || scheduledThresholds === void 0 ? void 0 : scheduledThresholds.find(function(param) {
        var threshold = param.threshold, availableFrom = param.availableFrom, availableTo = param.availableTo;
        return (0,isNotNullish/* isNotNullish */.l)(threshold) && (0,isNotNullish/* isNotNullish */.l)(availableFrom) && (0,isNotNullish/* isNotNullish */.l)(availableTo) && (0,dateCalculations/* isDateBetween */.zx)({
            startDate: new Date(availableFrom),
            endDate: new Date(availableTo),
            dateToCheck: dateToCheck
        });
    });
    var ref1;
    return (ref1 = activeScheduledThreshold === null || activeScheduledThreshold === void 0 ? void 0 : activeScheduledThreshold.threshold) !== null && ref1 !== void 0 ? ref1 : null;
};

;// CONCATENATED MODULE: ./utils/hasVariantFreeShipping.ts


var hasVariantFreeShipping = function(variation, freeShippingThreshold, scheduledFreeShipping) {
    if (!(0,isNotNullish/* isNotNullish */.l)(variation) || !(0,isNotNullish/* isNotNullish */.l)(freeShippingThreshold)) {
        return false;
    }
    var ref = variation.productPrice || {}, salePrice = ref.salePrice, price = ref.price;
    var priceToCheck = (0,isNotNullish/* isNotNullish */.l)(salePrice) ? salePrice : price;
    if (!(0,isNotNullish/* isNotNullish */.l)(priceToCheck)) return false;
    var currentScheduledFreeShippingThreshold = getScheduledFreeShippingThreshold(scheduledFreeShipping);
    var thresholdToCheck = currentScheduledFreeShippingThreshold !== null && currentScheduledFreeShippingThreshold !== void 0 ? currentScheduledFreeShippingThreshold : freeShippingThreshold;
    return priceToCheck > 0 && priceToCheck >= thresholdToCheck;
};

;// CONCATENATED MODULE: ./utils/getReturnsMessage.ts
var RETURN_RULE_ID;
(function(RETURN_RULE_ID) {
    RETURN_RULE_ID["TIMEFRAME"] = "Timeframe";
    RETURN_RULE_ID["SIX_DAYS"] = "6Days";
    RETURN_RULE_ID["NON_ELIGIBLE"] = "Non Eligible";
})(RETURN_RULE_ID || (RETURN_RULE_ID = {}));
var getReturnsMessage = function(translate, returnRuleId) {
    switch(returnRuleId){
        case RETURN_RULE_ID.TIMEFRAME:
            return translate("returnsTimeFrame", {
                days: 15
            });
        case RETURN_RULE_ID.SIX_DAYS:
            return translate("returnsTimeFrame", {
                days: 6
            });
        default:
            return translate("returnShipping");
    }
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/ShippingReturnsMessages.tsx







var ShippingReturnsMessages = function(param) {
    var variation = param.variation, freeShippingThreshold = param.freeShippingThreshold, returnsDisabled = param.returnsDisabled;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var thresholdDateToCheck = router.query.viewAt ? new Date(parseInt(router.query.viewAt)) : new Date();
    var scheduledFreeShippingThresholds = (0,useSiteConfig/* useSiteConfig */.N)().scheduledFreeShippingThresholds;
    var showFreeShippingMessage = hasVariantFreeShipping(variation, freeShippingThreshold, {
        scheduledThresholds: scheduledFreeShippingThresholds,
        dateToCheck: thresholdDateToCheck
    });
    var showReturnsMessage = !returnsDisabled && !(variation === null || variation === void 0 ? void 0 : variation.isFinalSale) && (variation === null || variation === void 0 ? void 0 : variation.returnRuleID) !== RETURN_RULE_ID.NON_ELIGIBLE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
        gap: "xs",
        className: "py-4",
        children: [
            showFreeShippingMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Callout */.UWt, {
                variant: "success",
                content: translate("freeShipping"),
                icon: "truck",
                dataTestId: "pdp-shipping-message"
            }),
            showReturnsMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Callout */.UWt, {
                variant: "muted",
                content: getReturnsMessage(translate, variation === null || variation === void 0 ? void 0 : variation.returnRuleID),
                icon: "loop-forward",
                dataTestId: "pdp-return-message"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/pages/ProductDetailsPages/index.tsx



















/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hH": function() { return /* binding */ createCategoryPageBreadcrumbLinks; },
  "A2": function() { return /* binding */ createProductBreadcrumbLinks; },
  "VD": function() { return /* binding */ fetchBreadcrumbRedirectPromises; }
});

// UNUSED EXPORTS: getLinksToCheck

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
;// CONCATENATED MODULE: ./gql/queries/urlRedirect.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UrlRedirect($path: String!) {\n    urlRedirectV2(path: $path) {\n      availableFrom\n      availableTo\n      redirectType\n      url\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var URL_REDIRECT_QUERY = (0,urql_core/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./utils/constructCategoryPath.ts
var constructCategoryPath = __webpack_require__(97729);
;// CONCATENATED MODULE: ./utils/breadcrumbRedirects.ts



/**
 * Creates an array of breadcrumb links from a category
 * @param currentCategory - The category data
 * @returns Array of breadcrumb links
 */ var createCategoryPageBreadcrumbLinks = function(currentCategory) {
    var categoryPath = (0,constructCategoryPath/* constructCategoryPath */.h)(currentCategory);
    return [
        {
            label: "home",
            url: ""
        }
    ].concat((0,_to_consumable_array/* default */.Z)(categoryPath));
};
/**
 * Creates breadcrumb links specifically for product detail pages
 * @param params - Object containing necessary data for product breadcrumbs
 * @returns Array of raw breadcrumb links ready for display
 */ var createProductBreadcrumbLinks = function(param) {
    var categoryById = param.categoryById, productName = param.productName, productLink = param.productLink, _isCustomizing = param.isCustomizing, isCustomizing = _isCustomizing === void 0 ? false : _isCustomizing, _customizeUrl = param.customizeUrl, customizeUrl = _customizeUrl === void 0 ? "" : _customizeUrl, _customizeLabel = param.customizeLabel, customizeLabel = _customizeLabel === void 0 ? "customize" : _customizeLabel, _isPersonalizing = param.isPersonalizing, isPersonalizing = _isPersonalizing === void 0 ? false : _isPersonalizing, _personalizeLabel = param.personalizeLabel, personalizeLabel = _personalizeLabel === void 0 ? "personaliseBreadcrumb" : _personalizeLabel;
    var categoryLinks = createCategoryPageBreadcrumbLinks(categoryById);
    var links = (0,_to_consumable_array/* default */.Z)(categoryLinks);
    if (productName && productLink) {
        links.push({
            label: productName,
            url: productLink,
            isAbsoluteUrl: true
        });
    }
    if (isCustomizing && customizeUrl) {
        links.push({
            label: customizeLabel,
            url: customizeUrl
        });
    }
    if (isPersonalizing) {
        links.push({
            label: personalizeLabel,
            url: ""
        });
    }
    return links;
};
/**
 * Gets the links that need to be checked for redirects
 * @param links - The full breadcrumb links array
 * @returns Array of links to check for redirects
 */ var getLinksToCheck = function(links) {
    // Skip first and last elements as per useBreadcrumbUrlRedirects implementation
    return links.slice(1, -1);
};
/**
 * Fetches URL redirect queries for breadcrumb links
 * @param client - The URQL client
 * @param links - The links to check for redirects
 * @returns Promise with the results of the redirect queries
 */ var fetchBreadcrumbRedirectPromises = function(client, links) {
    var linksToCheck = getLinksToCheck(links);
    // Create URL redirect queries for each breadcrumb link
    return linksToCheck.map(function(param) {
        var url = param.url;
        return client.query(URL_REDIRECT_QUERY, {
            path: url.startsWith("/") ? url.slice(1) : url
        });
    });
};


/***/ }),

/***/ 41403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ scrollTo; }
/* harmony export */ });
var scrollTo = function(id) {
    var yOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var element = document.getElementById(id);
    if (element) {
        var y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    }
};


/***/ })

}]);